export const contect_Data = [
    {
        title: 'HTML',
        name: 'HTML',
        image: '',
        url: 'QuizSelector?language=HTML',
        boxshadow: 'orange',
        textcolor: 'orange'
    },
    {
        title: 'CSS',
        name: 'CSS',
        image: '',
        url: 'QuizSelector?language=CSS',
        boxshadow: '#29B6F6',
        textcolor: '#29B6F6'
    },
    {
        title: 'JS',
        name: 'JavaScript',
        image: '',
        url: 'QuizSelector?language=JavaScript',
        boxshadow: '#69F0AE',
        textcolor: '#FFEB3B'
    },
    {
        title: 'React',
        name: 'React',
        image: '',
        url: 'QuizSelector?language=React',
        boxshadow: '#E040FB',
        textcolor: 'white'
    },
    {
        title: 'JAVA',
        name: 'JAVA',
        image: '',
        url: 'QuizSelector?language=JAVA',
        boxshadow: '#2979FF',
        textcolor: '#EF5350'
    },
    {
        title: 'Node',
        name: 'Node JS',
        image: '',
        url: 'QuizSelector?language=NodeJS',
        boxshadow: '#43853D',
        textcolor: '#4CAF50'
    },

]


export const QuizSelector_data = {
    JavaScript: [
        {
            problem: '1',
            url: 'QuizPage?language=JavaScript&level=1no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '2',
            url: 'QuizPage?language=JavaScript&level=2no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '3',
            url: 'QuizPage?language=JavaScript&level=3no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '4',
            url: 'QuizPage?language=JavaScript&level=4no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '5',
            url: 'QuizPage?language=JavaScript&level=5no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '6',
            url: 'QuizPage?language=JavaScript&level=6no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '7',
            url: 'QuizPage?language=JavaScript&level=7no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '8',
            url: 'QuizPage?language=JavaScript&level=8no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '9',
            url: 'QuizPage?language=JavaScript&level=9no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '10',
            url: 'QuizPage?language=JavaScript&level=10no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '11',
            url: 'QuizPage?language=JavaScript&level=11no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '12',
            url: 'QuizPage?language=JavaScript&level=12no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '13',
            url: 'QuizPage?language=JavaScript&level=13no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '14',
            url: 'QuizPage?language=JavaScript&level=14no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '15',
            url: 'QuizPage?language=JavaScript&level=15no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '16',
            url: 'QuizPage?language=JavaScript&level=16no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '17',
            url: 'QuizPage?language=JavaScript&level=17no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '18',
            url: 'QuizPage?language=JavaScript&level=18no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '19',
            url: 'QuizPage?language=JavaScript&level=19no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '20',
            url: 'QuizPage?language=JavaScript&level=20no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '21',
            url: 'QuizPage?language=JavaScript&level=21no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '22',
            url: 'QuizPage?language=JavaScript&level=22no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '23',
            url: 'QuizPage?language=JavaScript&level=23no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '24',
            url: 'QuizPage?language=JavaScript&level=24no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
        {
            problem: '25',
            url: 'QuizPage?language=JavaScript&level=25no',
            bordercolor: '#69F0AE',
            textcolor: '#FFEB3B'
        },
    ],
    HTML: [
        {
            problem: '1',
            url: 'QuizPage?language=HTML&level=1no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '2',
            url: 'QuizPage?language=HTML&level=2no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '3',
            url: 'QuizPage?language=HTML&level=3no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '4',
            url: 'QuizPage?language=HTML&level=4no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '5',
            url: 'QuizPage?language=HTML&level=5no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '6',
            url: 'QuizPage?language=HTML&level=6no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '7',
            url: 'QuizPage?language=HTML&level=7no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '8',
            url: 'QuizPage?language=HTML&level=8no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '9',
            url: 'QuizPage?language=HTML&level=9no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '10',
            url: 'QuizPage?language=HTML&level=10no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '11',
            url: 'QuizPage?language=HTML&level=11no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '12',
            url: 'QuizPage?language=HTML&level=12no',
            bordercolor: 'orange',
            textcolor: 'orange'
        },
        {
            problem: '13',
            url: 'QuizPage?language=HTML&level=13no',
            bordercolor: 'orange',
            textcolor: 'orange'
        }
    ],
    CSS: [
        {
            problem: '1',
            url: 'QuizPage?language=CSS&level=1no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '2',
            url: 'QuizPage?language=CSS&level=2no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '3',
            url: 'QuizPage?language=CSS&level=3no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '4',
            url: 'QuizPage?language=CSS&level=4no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '5',
            url: 'QuizPage?language=CSS&level=5no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '6',
            url: 'QuizPage?language=CSS&level=6no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '7',
            url: 'QuizPage?language=CSS&level=7no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '8',
            url: 'QuizPage?language=CSS&level=8no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '9',
            url: 'QuizPage?language=CSS&level=9no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '10',
            url: 'QuizPage?language=CSS&level=10no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '11',
            url: 'QuizPage?language=CSS&level=11no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '12',
            url: 'QuizPage?language=CSS&level=12no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '13',
            url: 'QuizPage?language=CSS&level=13no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '14',
            url: 'QuizPage?language=CSS&level=14no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '15',
            url: 'QuizPage?language=CSS&level=15no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '16',
            url: 'QuizPage?language=CSS&level=16no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
        {
            problem: '17',
            url: 'QuizPage?language=CSS&level=17no',
            bordercolor: '#29B6F6',
            textcolor: '#29B6F6'
        },
    ],
    React: [
        {
            problem: '1',
            url: 'QuizPage?language=React&level=1no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '2',
            url: 'QuizPage?language=React&level=2no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '3',
            url: 'QuizPage?language=React&level=3no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '4',
            url: 'QuizPage?language=React&level=4no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '5',
            url: 'QuizPage?language=React&level=5no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '6',
            url: 'QuizPage?language=React&level=6no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '7',
            url: 'QuizPage?language=React&level=7no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '8',
            url: 'QuizPage?language=React&level=8no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '9',
            url: 'QuizPage?language=React&level=9no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '10',
            url: 'QuizPage?language=React&level=10no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '11',
            url: 'QuizPage?language=React&level=11no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '12',
            url: 'QuizPage?language=React&level=12no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '13',
            url: 'QuizPage?language=React&level=13no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '14',
            url: 'QuizPage?language=React&level=14no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '15',
            url: 'QuizPage?language=React&level=15no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '16',
            url: 'QuizPage?language=React&level=16no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
        {
            problem: '17',
            url: 'QuizPage?language=React&level=17no',
            bordercolor: '#E040FB',
            textcolor: '#E040FB'
        },
    ],
    NodeJS: [
        {
            problem: '1',
            url: 'QuizPage?language=NodeJS&level=1no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '2',
            url: 'QuizPage?language=NodeJS&level=2no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '3',
            url: 'QuizPage?language=NodeJS&level=3no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '4',
            url: 'QuizPage?language=NodeJS&level=4no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '5',
            url: 'QuizPage?language=NodeJS&level=5no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '6',
            url: 'QuizPage?language=NodeJS&level=6no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '7',
            url: 'QuizPage?language=NodeJS&level=7no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '8',
            url: 'QuizPage?language=NodeJS&level=8no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '9',
            url: 'QuizPage?language=NodeJS&level=9no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '10',
            url: 'QuizPage?language=NodeJS&level=10no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '11',
            url: 'QuizPage?language=NodeJS&level=11no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
        {
            problem: '12',
            url: 'QuizPage?language=NodeJS&level=12no',
            bordercolor: '#43853D',
            textcolor: '#43853D'
        },
    ],
    JAVA: [
        {
            problem: '1',
            url: 'QuizPage?language=JAVA&level=1no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '2',
            url: 'QuizPage?language=JAVA&level=2no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '3',
            url: 'QuizPage?language=JAVA&level=3no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '4',
            url: 'QuizPage?language=JAVA&level=4no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '5',
            url: 'QuizPage?language=JAVA&level=5no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '6',
            url: 'QuizPage?language=JAVA&level=6no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '7',
            url: 'QuizPage?language=JAVA&level=7no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '8',
            url: 'QuizPage?language=JAVA&level=8no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
        {
            problem: '9',
            url: 'QuizPage?language=JAVA&level=9no',
            bordercolor: '#2979FF',
            textcolor: '#2979FF'
        },
    ]
}


export const quiz_page = {
    JavaScript: {
        '1no': [
            {
                question: "What does 'DOM' stand for in JavaScript?",
                options: ["Document Object Model", "Data Object Model", "Digital Output Module", "Desktop Object Model"],
                correctAnswer: "Document Object Model",
                category: "JavaScript"
            },
            {
                question: "What is the 'typeof' operator used for in JavaScript?",
                options: ["Checking the data type of a value", "Looping through an array", "Defining a new variable", "Comparing two strings"],
                correctAnswer: "Checking the data type of a value",
                category: "JavaScript"
            },
            {
                question: "Which keyword is used to declare a variable in JavaScript?",
                options: ["let", "var", "const", "int"],
                correctAnswer: "let",
                category: "JavaScript"
            },
            {
                question: "What is a closure in JavaScript?",
                options: ["A function with no parameters", "A variable declared outside a function", "A feature for object-oriented programming", "A function that captures its surrounding state"],
                correctAnswer: "A function that captures its surrounding state",
                category: "JavaScript"
            },
            {
                question: "What is the result of '2' + 2 in JavaScript?",
                options: ["22", "4", "TypeError", "42"],
                correctAnswer: "22",
                category: "JavaScript"
            },
            {
                question: "How do you declare a function in JavaScript?",
                options: ["function myFunction()", "myFunction: function()", "func myFunction()", "def myFunction()"],
                correctAnswer: "function myFunction()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'this' keyword in JavaScript?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JavaScript"
            },
            {
                question: "Which operator is used for strict equality in JavaScript?",
                options: ["==", "===", "!=", "!=="],
                correctAnswer: "===",
                category: "JavaScript"
            },
            {
                question: "What is an array in JavaScript?",
                options: ["A data type for storing numbers", "A collection of elements", "A type of loop", "A built-in function"],
                correctAnswer: "A collection of elements",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'console.log' function in JavaScript?",
                options: ["To log errors", "To clear the console", "To display output in the console", "To execute a function"],
                correctAnswer: "To display output in the console",
                category: "JavaScript"
            }
        ],
        '2no': [
            {
                question: "What is the purpose of 'console.log' in JavaScript?",
                options: ["To log errors", "To clear the console", "To display output in the console", "To execute a function"],
                correctAnswer: "To display output in the console",
                category: "JavaScript"
            },
            {
                question: "What is the 'typeof' operator used for in JavaScript?",
                options: ["Checking the data type of a value", "Looping through an array", "Defining a new variable", "Comparing two strings"],
                correctAnswer: "Checking the data type of a value",
                category: "JavaScript"
            },
            {
                question: "How do you declare a variable in JavaScript?",
                options: ["let", "var", "const", "int"],
                correctAnswer: "let",
                category: "JavaScript"
            },
            {
                question: "What is the result of '2' + 2 in JavaScript?",
                options: ["22", "4", "TypeError", "42"],
                correctAnswer: "22",
                category: "JavaScript"
            },
            {
                question: "What is a closure in JavaScript?",
                options: ["A function with no parameters", "A variable declared outside a function", "A feature for object-oriented programming", "A function that captures its surrounding state"],
                correctAnswer: "A function that captures its surrounding state",
                category: "JavaScript"
            },
            {
                question: "Which keyword is used to declare a function in JavaScript?",
                options: ["function myFunction()", "myFunction: function()", "func myFunction()", "def myFunction()"],
                correctAnswer: "function myFunction()",
                category: "JavaScript"
            },
            {
                question: "What is an array in JavaScript?",
                options: ["A data type for storing numbers", "A collection of elements", "A type of loop", "A built-in function"],
                correctAnswer: "A collection of elements",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'this' keyword in JavaScript?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JavaScript"
            },
            {
                question: "Which operator is used for strict equality in JavaScript?",
                options: ["==", "===", "!=", "!=="],
                correctAnswer: "===",
                category: "JavaScript"
            },
            {
                question: "What does 'DOM' stand for in JavaScript?",
                options: ["Document Object Model", "Data Object Model", "Digital Output Module", "Desktop Object Model"],
                correctAnswer: "Document Object Model",
                category: "JavaScript"
            }
        ],
        '3no': [
            {
                question: "What does 'NaN' stand for in JavaScript?",
                options: ["Not a Number", "New Assignment", "Negative Number", "No Argument"],
                correctAnswer: "Not a Number",
                category: "JavaScript"
            },
            {
                question: "Which loop is used to iterate over the properties of an object?",
                options: ["for loop", "while loop", "do...while loop", "for...in loop"],
                correctAnswer: "for...in loop",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'return' statement in a JavaScript function?",
                options: ["To print a value to the console", "To exit the function and return a value", "To declare a new variable", "To create a loop"],
                correctAnswer: "To exit the function and return a value",
                category: "JavaScript"
            },
            {
                question: "Which data structure is used to store a collection of key-value pairs in JavaScript?",
                options: ["Array", "Set", "Dictionary", "Object"],
                correctAnswer: "Object",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'try...catch' statement in JavaScript?",
                options: ["To define a function", "To create an infinite loop", "To handle exceptions and errors", "To style HTML elements"],
                correctAnswer: "To handle exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the 'innerHTML' property used for in JavaScript?",
                options: ["Changing the background color of an element", "Accessing the text content of an element", "Setting the source of an image", "Modifying the HTML content of an element"],
                correctAnswer: "Modifying the HTML content of an element",
                category: "JavaScript"
            },
            {
                question: "Which method is used to add an element to the end of an array in JavaScript?",
                options: ["push()", "pop()", "shift()", "unshift()"],
                correctAnswer: "push()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'addEventListener' method in JavaScript?",
                options: ["To remove an event listener", "To trigger an event", "To attach an event handler to an element", "To clear the console"],
                correctAnswer: "To attach an event handler to an element",
                category: "JavaScript"
            },
            {
                question: "What does the 'JSON' acronym stand for in JavaScript?",
                options: ["JavaScript Object Notation", "JavaScript Onyx Network", "JavaScript Object Navigator", "Java Standard Object Notation"],
                correctAnswer: "JavaScript Object Notation",
                category: "JavaScript"
            },
            {
                question: "Which keyword is used to break out of a loop in JavaScript?",
                options: ["stop", "exit", "break", "end"],
                correctAnswer: "break",
                category: "JavaScript"
            }
        ],
        '4no': [
            {
                question: "What is the primary purpose of the 'localStorage' object in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To send HTTP requests", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "Which keyword is used to prevent the execution of a JavaScript function?",
                options: ["halt", "stop", "return", "pause"],
                correctAnswer: "return",
                category: "JavaScript"
            },
            {
                question: "What is the difference between 'null' and 'undefined' in JavaScript?",
                options: ["They are the same", "null represents an empty object, undefined is the absence of value", "null represents the absence of value, undefined is an empty object", "There is no difference"],
                correctAnswer: "null represents an empty object, undefined is the absence of value",
                category: "JavaScript"
            },
            {
                question: "Which method is used to remove the last element from an array in JavaScript?",
                options: ["pop()", "push()", "shift()", "unshift()"],
                correctAnswer: "pop()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Math.random()' function in JavaScript?",
                options: ["To generate a random number between 0 and 1", "To calculate the square root of a number", "To round a number to the nearest integer", "To find the maximum value in an array"],
                correctAnswer: "To generate a random number between 0 and 1",
                category: "JavaScript"
            },
            {
                question: "Which operator is used to concatenate strings in JavaScript?",
                options: ["+", "++", "&&", "||"],
                correctAnswer: "+",
                category: "JavaScript"
            },
            {
                question: "What does the 'event.preventDefault()' method do in JavaScript?",
                options: ["Stops the event from occurring", "Starts a new event", "Logs the event to the console", "Triggers the event"],
                correctAnswer: "Stops the event from occurring",
                category: "JavaScript"
            },
            {
                question: "What is a callback function in JavaScript?",
                options: ["A function that runs immediately", "A function that is called after a specific task is completed", "A function that is executed only once", "A function that returns a value"],
                correctAnswer: "A function that is called after a specific task is completed",
                category: "JavaScript"
            },
            {
                question: "Which statement is used to exit a switch statement in JavaScript?",
                options: ["exit", "break", "return", "stop"],
                correctAnswer: "break",
                category: "JavaScript"
            },
            {
                question: "What does 'AJAX' stand for in JavaScript web development?",
                options: ["Asynchronous JavaScript and XML", "Advanced JavaScript and XHTML", "Automated JavaScript and XUL", "Actionable JavaScript and XML"],
                correctAnswer: "Asynchronous JavaScript and XML",
                category: "JavaScript"
            }
        ],
        '5no': [
            {
                question: "What is the purpose of the 'bind' method in JavaScript?",
                options: ["To create a new function with a specific 'this' value", "To bind two variables together", "To append elements to an array", "To change the CSS styling of an element"],
                correctAnswer: "To create a new function with a specific 'this' value",
                category: "JavaScript"
            },
            {
                question: "What is a callback hell (Pyramid of Doom) in JavaScript?",
                options: ["A nested set of if-else statements", "A design pattern for UI components", "A style of writing JavaScript code that involves deeply nested callback functions", "A popular JavaScript library"],
                correctAnswer: "A style of writing JavaScript code that involves deeply nested callback functions",
                category: "JavaScript"
            },
            {
                question: "What does the 'arguments' object refer to in JavaScript functions?",
                options: ["The parameters passed to a function", "The local variables declared inside a function", "The built-in objects of JavaScript", "The global variables of the program"],
                correctAnswer: "The parameters passed to a function",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'map' method in JavaScript for arrays?",
                options: ["To create a new array with the results of calling a provided function on each element", "To filter elements from an array", "To reverse the order of elements in an array", "To check if an array contains a specific value"],
                correctAnswer: "To create a new array with the results of calling a provided function on each element",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'constructor' property in JavaScript objects?",
                options: ["To define the constructor function of the object", "To create a new object", "To set the object's prototype", "To store the object's data"],
                correctAnswer: "To define the constructor function of the object",
                category: "JavaScript"
            },
            {
                question: "In JavaScript, what is the purpose of the 'setInterval' function?",
                options: ["To set the time zone of the browser", "To run a function at specified intervals", "To measure the execution time of a function", "To clear the console log"],
                correctAnswer: "To run a function at specified intervals",
                category: "JavaScript"
            },
            {
                question: "What is a JavaScript promise used for?",
                options: ["To declare a variable", "To handle asynchronous operations and provide a result in the future", "To define a function", "To create loops"],
                correctAnswer: "To handle asynchronous operations and provide a result in the future",
                category: "JavaScript"
            },
            {
                question: "What is a 'callback' in JavaScript?",
                options: ["A function that returns a value", "A function that runs immediately", "A function passed as an argument to another function to be executed later", "A built-in JavaScript object"],
                correctAnswer: "A function passed as an argument to another function to be executed later",
                category: "JavaScript"
            },
            {
                question: "What does 'ES6' refer to in JavaScript?",
                options: ["A web browser", "A JavaScript framework", "The sixth version of the ECMAScript language specification", "A popular JavaScript library"],
                correctAnswer: "The sixth version of the ECMAScript language specification",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'export' statement in JavaScript modules?",
                options: ["To import external libraries", "To define a function", "To export functions, objects, or values for use in other modules", "To generate random numbers"],
                correctAnswer: "To export functions, objects, or values for use in other modules",
                category: "JavaScript"
            }
        ],
        '6no': [
            {
                question: "What does the 'spread operator' (...) do in JavaScript?",
                options: ["It performs arithmetic operations", "It creates a shallow copy of an array or object", "It defines a function", "It generates random numbers"],
                correctAnswer: "It creates a shallow copy of an array or object",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'async' and 'await' keywords in JavaScript?",
                options: ["To define a function", "To indicate that a function returns a promise", "To handle asynchronous code in a more synchronous style", "To perform network requests"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            },
            {
                question: "What is the difference between 'null' and 'undefined' in JavaScript?",
                options: ["They are the same", "null represents an empty object, undefined is the absence of value", "null represents the absence of value, undefined is an empty object", "There is no difference"],
                correctAnswer: "null represents an empty object, undefined is the absence of value",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'let' keyword in JavaScript?",
                options: ["To declare a constant variable", "To define a function", "To declare a block-scoped variable", "To create a global variable"],
                correctAnswer: "To declare a block-scoped variable",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'push' method in JavaScript arrays?",
                options: ["To pop an element from the array", "To add an element to the beginning of the array", "To remove an element from the array", "To add an element to the end of the array"],
                correctAnswer: "To add an element to the end of the array",
                category: "JavaScript"
            },
            {
                question: "Which operator is used to compare two values for equality without type conversion in JavaScript?",
                options: ["==", "===", "!=", "!=="],
                correctAnswer: "===",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'document.getElementById' method in JavaScript?",
                options: ["To retrieve a list of all elements with a specific class", "To get the value of a form input field", "To select an element by its unique ID", "To hide elements on a webpage"],
                correctAnswer: "To select an element by its unique ID",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'NaN' value in JavaScript?",
                options: ["To represent an invalid number", "To calculate mathematical operations", "To store large integers", "To define a constant value"],
                correctAnswer: "To represent an invalid number",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof null' in JavaScript?",
                options: ["object", "null", "undefined", "string"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What does the 'JSON' acronym stand for in JavaScript?",
                options: ["JavaScript Object Notation", "JavaScript Onyx Network", "JavaScript Object Navigator", "Java Standard Object Notation"],
                correctAnswer: "JavaScript Object Notation",
                category: "JavaScript"
            }
        ],
        '7no': [
            {
                question: "What is the purpose of the 'this' keyword in JavaScript?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JavaScript"
            },
            {
                question: "What is a 'Promise' in JavaScript used for?",
                options: ["To declare a variable", "To handle asynchronous operations and provide a result in the future", "To define a function", "To create loops"],
                correctAnswer: "To handle asynchronous operations and provide a result in the future",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 + '5' in JavaScript?",
                options: ["55", "10", "TypeError", "5 + '5' is not a valid expression"],
                correctAnswer: "55",
                category: "JavaScript"
            },
            {
                question: "Which method is used to remove the first element from an array in JavaScript?",
                options: ["shift()", "unshift()", "pop()", "push()"],
                correctAnswer: "shift()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'typeof' operator in JavaScript?",
                options: ["To compare two values", "To check if a variable is defined", "To determine the data type of a value", "To declare a new variable"],
                correctAnswer: "To determine the data type of a value",
                category: "JavaScript"
            },
            {
                question: "What is a 'constructor' function in JavaScript used for?",
                options: ["To create an object", "To perform mathematical calculations", "To stop execution of a function", "To print messages to the console"],
                correctAnswer: "To create an object",
                category: "JavaScript"
            },
            {
                question: "Which statement is used to define a block of code in JavaScript?",
                options: ["define", "block", "begin", "function"],
                correctAnswer: "function",
                category: "JavaScript"
            },
            {
                question: "What is a 'closure' in JavaScript?",
                options: ["A function with no parameters", "A variable declared outside a function", "A feature for object-oriented programming", "A function that captures its surrounding state"],
                correctAnswer: "A function that captures its surrounding state",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'parseInt' function in JavaScript?",
                options: ["To format strings", "To convert a string to an integer", "To add two numbers", "To declare a variable"],
                correctAnswer: "To convert a string to an integer",
                category: "JavaScript"
            },
            {
                question: "What does the 'Array.isArray()' method do in JavaScript?",
                options: ["Checks if a variable is an array", "Adds elements to an array", "Sorts the elements of an array", "Converts an array to a string"],
                correctAnswer: "Checks if a variable is an array",
                category: "JavaScript"
            }
        ],
        '8no': [
            {
                question: "What is the purpose of the 'event.preventDefault()' method in JavaScript?",
                options: ["To log errors", "To clear the console", "To stop the execution of the event", "To prevent the default behavior of an event"],
                correctAnswer: "To prevent the default behavior of an event",
                category: "JavaScript"
            },
            {
                question: "What does the 'for...of' loop iterate over in JavaScript?",
                options: ["Object properties", "Array elements", "Function parameters", "Global variables"],
                correctAnswer: "Array elements",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.filter()' method in JavaScript?",
                options: ["To create a new array with the results of calling a provided function on each element", "To change the original array", "To remove elements from the array", "To add elements to the array"],
                correctAnswer: "To create a new array with the results of calling a provided function on each element",
                category: "JavaScript"
            },
            {
                question: "What is a 'callback function' used for in JavaScript?",
                options: ["To declare a variable", "To execute a function immediately", "To handle asynchronous operations or events", "To create loops"],
                correctAnswer: "To handle asynchronous operations or events",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 == '5' in JavaScript?",
                options: ["true", "false", "undefined", "TypeError"],
                correctAnswer: "true",
                category: "JavaScript"
            },
            {
                question: "What is the 'NaN' value used for in JavaScript?",
                options: ["To indicate a successful operation", "To represent an invalid number", "To stop a loop", "To declare a function"],
                correctAnswer: "To represent an invalid number",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' object in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To create animations", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype' in JavaScript?",
                options: ["A type of data structure", "A built-in JavaScript function", "An object used for inheritance", "A popular JavaScript library"],
                correctAnswer: "An object used for inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'setTimeout' function in JavaScript?",
                options: ["To define a function", "To execute a function immediately", "To delay the execution of a function", "To create a loop"],
                correctAnswer: "To delay the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the 'async/await' feature used for in JavaScript?",
                options: ["To replace all 'if' statements", "To handle asynchronous code in a more synchronous style", "To define a function", "To create a loop"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            }
        ],
        '9no': [
            {
                question: "What is the purpose of the 'Promise.all()' method in JavaScript?",
                options: ["To create a new Promise", "To handle asynchronous operations sequentially", "To wait for all Promises to resolve or one to reject", "To execute a function immediately"],
                correctAnswer: "To wait for all Promises to resolve or one to reject",
                category: "JavaScript"
            },
            {
                question: "What does 'IIFE' stand for in JavaScript?",
                options: ["Immediate Increment Function Expression", "Inline If-Else Expression", "Immediately Invoked Function Expression", "Internal Inheritance Function Execution"],
                correctAnswer: "Immediately Invoked Function Expression",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Object.keys()' method in JavaScript?",
                options: ["To check if an object is empty", "To return an array of an object's enumerable property names", "To convert an object to a string", "To define a function"],
                correctAnswer: "To return an array of an object's enumerable property names",
                category: "JavaScript"
            },
            {
                question: "What is a 'generator' function in JavaScript used for?",
                options: ["To generate random numbers", "To create a new object", "To handle asynchronous code", "To pause and resume the execution of a function"],
                correctAnswer: "To pause and resume the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.reduce()' method in JavaScript?",
                options: ["To reverse the elements of an array", "To check if an array contains a specific value", "To reduce the array to a single value using a callback function", "To add elements to the array"],
                correctAnswer: "To reduce the array to a single value using a callback function",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof []' in JavaScript?",
                options: ["array", "object", "array", "undefined"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What does the 'try...catch' statement in JavaScript help with?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'import' statement in JavaScript modules?",
                options: ["To format strings", "To import functions or objects from other modules", "To execute a function", "To stop execution of a function"],
                correctAnswer: "To import functions or objects from other modules",
                category: "JavaScript"
            },
            {
                question: "What is the 'Destructuring Assignment' feature in JavaScript used for?",
                options: ["To destroy objects", "To create new variables", "To extract values from arrays or objects", "To prevent code execution"],
                correctAnswer: "To extract values from arrays or objects",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'fetch' API in JavaScript?",
                options: ["To fetch data from a database", "To change the color of elements", "To create animations", "To make network requests and retrieve data"],
                correctAnswer: "To make network requests and retrieve data",
                category: "JavaScript"
            }
        ],
        '10no': [
            {
                question: "What is the purpose of the 'local storage' in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To define CSS styles", "To create animations"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype chain' in JavaScript used for?",
                options: ["To define a function", "To create loops", "To create a hierarchy of objects with inheritance", "To stop execution of a function"],
                correctAnswer: "To create a hierarchy of objects with inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'JSON.stringify()' method in JavaScript?",
                options: ["To parse a JSON string", "To convert a JavaScript object or value to a JSON string", "To remove properties from a JSON object", "To create a deep copy of a JSON object"],
                correctAnswer: "To convert a JavaScript object or value to a JSON string",
                category: "JavaScript"
            },
            {
                question: "What is the 'call' method used for in JavaScript?",
                options: ["To call a function immediately", "To invoke a function with a specific 'this' value", "To make a network request", "To declare a variable"],
                correctAnswer: "To invoke a function with a specific 'this' value",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'for...in' loop in JavaScript?",
                options: ["To iterate over the values of an array", "To create a new array", "To define a function", "To iterate over the properties of an object"],
                correctAnswer: "To iterate over the properties of an object",
                category: "JavaScript"
            },
            {
                question: "What is the 'DOM' acronym used for in web development?",
                options: ["Document Object Model", "Data Object Model", "Desktop Object Model", "Document Over Model"],
                correctAnswer: "Document Object Model",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'addEventListener' method in JavaScript?",
                options: ["To remove an event listener", "To trigger an event", "To attach an event handler to an element", "To clear the console log"],
                correctAnswer: "To attach an event handler to an element",
                category: "JavaScript"
            },
            {
                question: "What is a 'hoisting' in JavaScript?",
                options: ["A way to declare variables", "A method to move code to the top of the file", "The default behavior of moving variable declarations to the top of the current scope", "A type of data structure"],
                correctAnswer: "The default behavior of moving variable declarations to the top of the current scope",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof undefined' in JavaScript?",
                options: ["number", "undefined", "string", "NaN"],
                correctAnswer: "undefined",
                category: "JavaScript"
            },
            {
                question: "What is the 'fetch' API used for in JavaScript?",
                options: ["To perform mathematical calculations", "To make network requests and retrieve data", "To create animations", "To define CSS styles"],
                correctAnswer: "To make network requests and retrieve data",
                category: "JavaScript"
            }
        ],
        '11no': [
            {
                question: "What is the purpose of the 'this' keyword in JavaScript?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JavaScript"
            },
            {
                question: "What is a 'Promise' in JavaScript used for?",
                options: ["To declare a variable", "To handle asynchronous operations and provide a result in the future", "To define a function", "To create loops"],
                correctAnswer: "To handle asynchronous operations and provide a result in the future",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 + '5' in JavaScript?",
                options: ["55", "10", "TypeError", "5 + '5' is not a valid expression"],
                correctAnswer: "55",
                category: "JavaScript"
            },
            {
                question: "Which method is used to remove the first element from an array in JavaScript?",
                options: ["shift()", "unshift()", "pop()", "push()"],
                correctAnswer: "shift()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'typeof' operator in JavaScript?",
                options: ["To compare two values", "To check if a variable is defined", "To determine the data type of a value", "To declare a new variable"],
                correctAnswer: "To determine the data type of a value",
                category: "JavaScript"
            },
            {
                question: "What is a 'constructor' function in JavaScript used for?",
                options: ["To create an object", "To perform mathematical calculations", "To stop execution of a function", "To print messages to the console"],
                correctAnswer: "To create an object",
                category: "JavaScript"
            },
            {
                question: "Which statement is used to define a block of code in JavaScript?",
                options: ["define", "block", "begin", "function"],
                correctAnswer: "function",
                category: "JavaScript"
            },
            {
                question: "What is a 'closure' in JavaScript?",
                options: ["A function with no parameters", "A variable declared outside a function", "A feature for object-oriented programming", "A function that captures its surrounding state"],
                correctAnswer: "A function that captures its surrounding state",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'parseInt' function in JavaScript?",
                options: ["To format strings", "To convert a string to an integer", "To add two numbers", "To declare a variable"],
                correctAnswer: "To convert a string to an integer",
                category: "JavaScript"
            },
            {
                question: "What does the 'Array.isArray()' method do in JavaScript?",
                options: ["Checks if a variable is an array", "Adds elements to an array", "Sorts the elements of an array", "Converts an array to a string"],
                correctAnswer: "Checks if a variable is an array",
                category: "JavaScript"
            }
        ],
        '12no': [
            {
                question: "What is the purpose of the 'Promise.all()' method in JavaScript?",
                options: ["To create a new Promise", "To handle asynchronous operations sequentially", "To wait for all Promises to resolve or one to reject", "To execute a function immediately"],
                correctAnswer: "To wait for all Promises to resolve or one to reject",
                category: "JavaScript"
            },
            {
                question: "What does 'IIFE' stand for in JavaScript?",
                options: ["Immediate Increment Function Expression", "Inline If-Else Expression", "Immediately Invoked Function Expression", "Internal Inheritance Function Execution"],
                correctAnswer: "Immediately Invoked Function Expression",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Object.keys()' method in JavaScript?",
                options: ["To check if an object is empty", "To return an array of an object's enumerable property names", "To convert an object to a string", "To define a function"],
                correctAnswer: "To return an array of an object's enumerable property names",
                category: "JavaScript"
            },
            {
                question: "What is a 'generator' function in JavaScript used for?",
                options: ["To generate random numbers", "To create a new object", "To handle asynchronous code", "To pause and resume the execution of a function"],
                correctAnswer: "To pause and resume the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.reduce()' method in JavaScript?",
                options: ["To reverse the elements of an array", "To check if an array contains a specific value", "To reduce the array to a single value using a callback function", "To add elements to the array"],
                correctAnswer: "To reduce the array to a single value using a callback function",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof []' in JavaScript?",
                options: ["array", "object", "array", "undefined"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What does the 'try...catch' statement in JavaScript help with?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'import' statement in JavaScript modules?",
                options: ["To format strings", "To import functions or objects from other modules", "To execute a function", "To stop execution of a function"],
                correctAnswer: "To import functions or objects from other modules",
                category: "JavaScript"
            },
            {
                question: "What is the 'Destructuring Assignment' feature in JavaScript used for?",
                options: ["To destroy objects", "To create new variables", "To extract values from arrays or objects", "To prevent code execution"],
                correctAnswer: "To extract values from arrays or objects",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'fetch' API in JavaScript?",
                options: ["To fetch data from a database", "To change the color of elements", "To create animations", "To make network requests and retrieve data"],
                correctAnswer: "To make network requests and retrieve data",
                category: "JavaScript"
            }
        ],
        '13no': [
            {
                question: "What is the 'spread operator' (...) used for in JavaScript?",
                options: ["It performs arithmetic operations", "It creates a shallow copy of an array or object", "It defines a function", "It generates random numbers"],
                correctAnswer: "It creates a shallow copy of an array or object",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'async' and 'await' keywords in JavaScript?",
                options: ["To define a function", "To indicate that a function returns a promise", "To handle asynchronous code in a more synchronous style", "To perform network requests"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            },
            {
                question: "What is the difference between 'null' and 'undefined' in JavaScript?",
                options: ["They are the same", "null represents an empty object, undefined is the absence of value", "null represents the absence of value, undefined is an empty object", "There is no difference"],
                correctAnswer: "null represents an empty object, undefined is the absence of value",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'let' keyword in JavaScript?",
                options: ["To declare a constant variable", "To define a function", "To declare a block-scoped variable", "To create a global variable"],
                correctAnswer: "To declare a block-scoped variable",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'push' method in JavaScript arrays?",
                options: ["To pop an element from the array", "To add an element to the beginning of the array", "To remove an element from the array", "To add an element to the end of the array"],
                correctAnswer: "To add an element to the end of the array",
                category: "JavaScript"
            },
            {
                question: "Which operator is used to compare two values for equality without type conversion in JavaScript?",
                options: ["==", "===", "!=", "!=="],
                correctAnswer: "===",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'document.getElementById' method in JavaScript?",
                options: ["To retrieve a list of all elements with a specific class", "To get the value of a form input field", "To select an element by its unique ID", "To hide elements on a webpage"],
                correctAnswer: "To select an element by its unique ID",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'NaN' value in JavaScript?",
                options: ["To represent an invalid number", "To calculate mathematical operations", "To store large integers", "To define a constant value"],
                correctAnswer: "To represent an invalid number",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof null' in JavaScript?",
                options: ["object", "null", "undefined", "string"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What does the 'JSON' acronym stand for in JavaScript?",
                options: ["JavaScript Object Notation", "JavaScript Onyx Network", "JavaScript Object Navigator", "Java Standard Object Notation"],
                correctAnswer: "JavaScript Object Notation",
                category: "JavaScript"
            }
        ],
        '14no': [
            {
                question: "What is the purpose of the 'event.preventDefault()' method in JavaScript?",
                options: ["To log errors", "To clear the console", "To stop the execution of the event", "To prevent the default behavior of an event"],
                correctAnswer: "To prevent the default behavior of an event",
                category: "JavaScript"
            },
            {
                question: "What does the 'for...of' loop iterate over in JavaScript?",
                options: ["Object properties", "Array elements", "Function parameters", "Global variables"],
                correctAnswer: "Array elements",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.filter()' method in JavaScript?",
                options: ["To create a new array with the results of calling a provided function on each element", "To change the original array", "To remove elements from the array", "To add elements to the array"],
                correctAnswer: "To create a new array with the results of calling a provided function on each element",
                category: "JavaScript"
            },
            {
                question: "What is a 'callback function' used for in JavaScript?",
                options: ["To declare a variable", "To execute a function immediately", "To handle asynchronous operations or events", "To create loops"],
                correctAnswer: "To handle asynchronous operations or events",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 == '5' in JavaScript?",
                options: ["true", "false", "undefined", "TypeError"],
                correctAnswer: "true",
                category: "JavaScript"
            },
            {
                question: "What is the 'NaN' value used for in JavaScript?",
                options: ["To indicate a successful operation", "To represent an invalid number", "To stop a loop", "To declare a function"],
                correctAnswer: "To represent an invalid number",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' object in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To create animations", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype' in JavaScript?",
                options: ["A type of data structure", "A built-in JavaScript function", "An object used for inheritance", "A popular JavaScript library"],
                correctAnswer: "An object used for inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'setTimeout' function in JavaScript?",
                options: ["To define a function", "To execute a function immediately", "To delay the execution of a function", "To create a loop"],
                correctAnswer: "To delay the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the 'async/await' feature used for in JavaScript?",
                options: ["To replace all 'if' statements", "To handle asynchronous code in a more synchronous style", "To define a function", "To create a loop"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            }
        ],
        '15no': [
            {
                question: "What is the purpose of the 'Object.keys()' method in JavaScript?",
                options: ["To create a new object", "To retrieve the keys of an object as an array", "To check if an object has a specific property", "To remove properties from an object"],
                correctAnswer: "To retrieve the keys of an object as an array",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'let' keyword in JavaScript?",
                options: ["To declare a constant variable", "To define a function", "To declare a block-scoped variable", "To create a global variable"],
                correctAnswer: "To declare a block-scoped variable",
                category: "JavaScript"
            },
            {
                question: "How is an arrow function different from a regular function in JavaScript?",
                options: ["Arrow functions cannot have parameters", "Arrow functions cannot return values", "Arrow functions do not have a 'this' context", "Arrow functions cannot be used as callbacks"],
                correctAnswer: "Arrow functions do not have a 'this' context",
                category: "JavaScript"
            },
            {
                question: "What does the 'Promise.all()' method do in JavaScript?",
                options: ["Executes multiple promises in parallel and returns a single promise", "Resolves the first promise in an array", "Rejects if any promise in an array rejects", "Creates a new promise"],
                correctAnswer: "Executes multiple promises in parallel and returns a single promise",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.reduce()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To combine array elements into a single value", "To filter elements from an array"],
                correctAnswer: "To combine array elements into a single value",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof NaN' in JavaScript?",
                options: ["number", "undefined", "string", "NaN"],
                correctAnswer: "number",
                category: "JavaScript"
            },
            {
                question: "How can you check if a variable is an array in JavaScript?",
                options: ["Using the 'isArray' method", "By checking if the variable has a 'length' property", "By using the 'typeof' operator", "There is no way to check if a variable is an array"],
                correctAnswer: "Using the 'isArray' method",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.slice()' method in JavaScript?",
                options: ["To add elements to the beginning of an array", "To create a shallow copy of an array", "To remove the last element of an array", "To reverse the order of array elements"],
                correctAnswer: "To create a shallow copy of an array",
                category: "JavaScript"
            },
            {
                question: "What does the 'strict mode' in JavaScript do?",
                options: ["Enforces a more relaxed syntax", "Throws runtime errors for common coding mistakes", "Disables certain JavaScript features", "Changes the default behavior of JavaScript"],
                correctAnswer: "Throws runtime errors for common coding mistakes",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'encodeURIComponent()' function in JavaScript?",
                options: ["To decode a URI component", "To encode a URI component", "To retrieve the current URL", "To create a new HTML element"],
                correctAnswer: "To encode a URI component",
                category: "JavaScript"
            }
        ],
        '16no': [
            {
                question: "What is the purpose of the 'Array.isArray()' method in JavaScript?",
                options: ["To check if a value is an array", "To create a new array", "To sort an array", "To filter array elements"],
                correctAnswer: "To check if a value is an array",
                category: "JavaScript"
            },
            {
                question: "What does the acronym 'IIFE' stand for in JavaScript?",
                options: ["Immediate Iterative Function Execution", "Internal Inline File Extension", "Instantiated Independent Function Expression", "Immediately Invoked Function Expression"],
                correctAnswer: "Immediately Invoked Function Expression",
                category: "JavaScript"
            },
            {
                question: "How is 'null' different from 'undefined' in JavaScript?",
                options: ["They are the same", "null represents an empty object, undefined is the absence of value", "null represents the absence of value, undefined is an empty object", "There is no difference"],
                correctAnswer: "null represents an empty object, undefined is the absence of value",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.forEach()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To iterate over each element in an array and perform a function", "To reverse the order of array elements"],
                correctAnswer: "To iterate over each element in an array and perform a function",
                category: "JavaScript"
            },
            {
                question: "How can you convert a string to lowercase in JavaScript?",
                options: ["string.toLowerCase()", "string.upperCase()", "string.toLower()", "string.caseLower()"],
                correctAnswer: "string.toLowerCase()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'document.write()' method in JavaScript?",
                options: ["To write content to the console log", "To write content directly into the HTML document", "To create a new HTML element", "To define a function"],
                correctAnswer: "To write content directly into the HTML document",
                category: "JavaScript"
            },
            {
                question: "What is the result of '3 * '5' in JavaScript?",
                options: ["15", "8", "TypeError", "3 * '5' is not a valid expression"],
                correctAnswer: "15",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Math.random()' function in JavaScript?",
                options: ["To generate a random number between 0 (inclusive) and 1 (exclusive)", "To round a number to the nearest integer", "To perform mathematical operations", "To create a new Math object"],
                correctAnswer: "To generate a random number between 0 (inclusive) and 1 (exclusive)",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'super' keyword in JavaScript classes?",
                options: ["To call the constructor of the superclass", "To access the prototype of the superclass", "To create a new instance of the superclass", "To stop the execution of a function"],
                correctAnswer: "To call the constructor of the superclass",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.pop()' method in JavaScript?",
                options: ["To remove the first element from an array", "To add an element to the beginning of an array", "To remove the last element from an array", "To add an element to the end of an array"],
                correctAnswer: "To remove the last element from an array",
                category: "JavaScript"
            }
        ],
        '17no': [
            {
                question: "What does the 'const' keyword signify in JavaScript?",
                options: ["A variable that cannot be reassigned", "A constant function", "A constant loop", "A variable with constant values"],
                correctAnswer: "A variable that cannot be reassigned",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.filter()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To remove elements from an array based on a condition", "To reverse the order of array elements"],
                correctAnswer: "To remove elements from an array based on a condition",
                category: "JavaScript"
            },
            {
                question: "How can you convert a string to uppercase in JavaScript?",
                options: ["string.toUpperCase()", "string.lowerCase()", "string.toUpper()", "string.caseUpper()"],
                correctAnswer: "string.toUpperCase()",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'true + 1' in JavaScript?",
                options: ["2", "true1", "TypeError", "false"],
                correctAnswer: "2",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.unshift()' method in JavaScript?",
                options: ["To remove the first element from an array", "To add an element to the beginning of an array", "To remove the last element from an array", "To add an element to the end of an array"],
                correctAnswer: "To add an element to the beginning of an array",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'event.preventDefault()' method in JavaScript?",
                options: ["To stop the propagation of an event", "To prevent the default action associated with an event", "To trigger an event", "To clear the console log"],
                correctAnswer: "To prevent the default action associated with an event",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.indexOf()' method in JavaScript?",
                options: ["To add an element to the beginning of an array", "To find the index of a specific element in an array", "To remove elements from an array", "To create a new array with the same elements as the original"],
                correctAnswer: "To find the index of a specific element in an array",
                category: "JavaScript"
            },
            {
                question: "What does the term 'hoisting' refer to in JavaScript?",
                options: ["Lifting heavy objects in the code", "Moving variable declarations to the top of the scope", "Creating a new function", "Animating elements on a webpage"],
                correctAnswer: "Moving variable declarations to the top of the scope",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.join()' method in JavaScript?",
                options: ["To join two arrays into one", "To create a new array with the same elements as the original", "To convert an array to a string with specified separator", "To split a string into an array"],
                correctAnswer: "To convert an array to a string with specified separator",
                category: "JavaScript"
            },
            {
                question: "What is the 'spread syntax' used for in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To spread elements of an array or object", "To define a new function", "To reverse the order of array elements"],
                correctAnswer: "To spread elements of an array or object",
                category: "JavaScript"
            }
        ],
        '18no': [
            {
                question: "What is the purpose of the 'try...catch' statement in JavaScript?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'import' statement in JavaScript modules?",
                options: ["To format strings", "To import functions or objects from other modules", "To execute a function", "To stop execution of a function"],
                correctAnswer: "To import functions or objects from other modules",
                category: "JavaScript"
            },
            {
                question: "What is the 'Destructuring Assignment' feature in JavaScript used for?",
                options: ["To destroy objects", "To create new variables", "To extract values from arrays or objects", "To prevent code execution"],
                correctAnswer: "To extract values from arrays or objects",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'this' keyword in JavaScript?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JavaScript"
            },
            {
                question: "What is a 'Promise' in JavaScript used for?",
                options: ["To declare a variable", "To handle asynchronous operations and provide a result in the future", "To define a function", "To create loops"],
                correctAnswer: "To handle asynchronous operations and provide a result in the future",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 + '5' in JavaScript?",
                options: ["55", "10", "TypeError", "5 + '5' is not a valid expression"],
                correctAnswer: "55",
                category: "JavaScript"
            },
            {
                question: "Which method is used to remove the first element from an array in JavaScript?",
                options: ["shift()", "unshift()", "pop()", "push()"],
                correctAnswer: "shift()",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'typeof' operator in JavaScript?",
                options: ["To compare two values", "To check if a variable is defined", "To determine the data type of a value", "To declare a new variable"],
                correctAnswer: "To determine the data type of a value",
                category: "JavaScript"
            },
            {
                question: "What is a 'constructor' function in JavaScript used for?",
                options: ["To create an object", "To perform mathematical calculations", "To stop execution of a function", "To print messages to the console"],
                correctAnswer: "To create an object",
                category: "JavaScript"
            },
            {
                question: "Which statement is used to define a block of code in JavaScript?",
                options: ["define", "block", "begin", "function"],
                correctAnswer: "function",
                category: "JavaScript"
            }
        ],
        '19no': [
            {
                question: "What is the result of '5 * '5' in JavaScript?",
                options: ["25", "10", "TypeError", "5 * '5' is not a valid expression"],
                correctAnswer: "25",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.map()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To remove elements from the array", "To concatenate multiple arrays"],
                correctAnswer: "To create a new array with the same elements as the original",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'const' keyword in JavaScript?",
                options: ["To declare a constant variable", "To define a function", "To declare a block-scoped variable", "To create a global variable"],
                correctAnswer: "To declare a constant variable",
                category: "JavaScript"
            },
            {
                question: "What does the 'window' object represent in a web browser's JavaScript environment?",
                options: ["The web page's content", "The user's computer", "The browser's settings", "The global JavaScript environment"],
                correctAnswer: "The global JavaScript environment",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To create animations", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is the 'document' object in JavaScript used for?",
                options: ["To execute a function", "To define CSS styles", "To access and manipulate the contents of a web page", "To declare a constant variable"],
                correctAnswer: "To access and manipulate the contents of a web page",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'addEventListener' method in JavaScript?",
                options: ["To remove an event listener", "To trigger an event", "To attach an event handler to an element", "To clear the console log"],
                correctAnswer: "To attach an event handler to an element",
                category: "JavaScript"
            },
            {
                question: "What does the 'localStorage' allow you to store in the browser?",
                options: ["Only numbers", "Any data as long as it's a string", "Arrays and objects", "Functions and variables"],
                correctAnswer: "Any data as long as it's a string",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'document.querySelector()' method in JavaScript?",
                options: ["To select the first element that matches a specified CSS selector", "To retrieve the browser's current URL", "To create a new HTML element", "To define a function"],
                correctAnswer: "To select the first element that matches a specified CSS selector",
                category: "JavaScript"
            },
            {
                question: "What is the 'call' method used for in JavaScript?",
                options: ["To call a function immediately", "To invoke a function with a specific 'this' value", "To make a network request", "To declare a variable"],
                correctAnswer: "To invoke a function with a specific 'this' value",
                category: "JavaScript"
            }
        ],
        '20no': [
            {
                question: "What is the purpose of the 'document.createElement()' method in JavaScript?",
                options: ["To create a new variable", "To define a function", "To select an element by its ID", "To create a new HTML element"],
                correctAnswer: "To create a new HTML element",
                category: "JavaScript"
            },
            {
                question: "What does 'ES6' stand for in the context of JavaScript?",
                options: ["Electronic System 6", "Enhanced Scripting 6", "ECMAScript 6", "Elementary Syntax 6"],
                correctAnswer: "ECMAScript 6",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' object in JavaScript?",
                options: ["To format strings", "To import functions or objects from other modules", "To execute a function", "To store data temporarily in the browser"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is the 'JSON' acronym used for in JavaScript?",
                options: ["JavaScript Object Notation", "JavaScript Onyx Network", "JavaScript Object Navigator", "Java Standard Object Notation"],
                correctAnswer: "JavaScript Object Notation",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'addEventListener' method in JavaScript?",
                options: ["To remove an event listener", "To trigger an event", "To attach an event handler to an element", "To clear the console log"],
                correctAnswer: "To attach an event handler to an element",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype' in JavaScript?",
                options: ["A type of data structure", "A built-in JavaScript function", "An object used for inheritance", "A popular JavaScript library"],
                correctAnswer: "An object used for inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'setTimeout' function in JavaScript?",
                options: ["To define a function", "To execute a function immediately", "To delay the execution of a function", "To create a loop"],
                correctAnswer: "To delay the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the 'async/await' feature used for in JavaScript?",
                options: ["To replace all 'if' statements", "To handle asynchronous code in a more synchronous style", "To define a function", "To create a loop"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'try...catch' statement in JavaScript?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 == '5' in JavaScript?",
                options: ["true", "false", "undefined", "TypeError"],
                correctAnswer: "true",
                category: "JavaScript"
            }
        ],
        '21no': [
            {
                question: "What is the purpose of the 'document.getElementById' method in JavaScript?",
                options: ["To retrieve a list of all elements with a specific class", "To get the value of a form input field", "To select an element by its unique ID", "To hide elements on a webpage"],
                correctAnswer: "To select an element by its unique ID",
                category: "JavaScript"
            },
            {
                question: "What is a 'callback function' used for in JavaScript?",
                options: ["To declare a variable", "To execute a function immediately", "To handle asynchronous operations or events", "To create loops"],
                correctAnswer: "To handle asynchronous operations or events",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 + '5' in JavaScript?",
                options: ["55", "10", "TypeError", "5 + '5' is not a valid expression"],
                correctAnswer: "55",
                category: "JavaScript"
            },
            {
                question: "What is the 'NaN' value used for in JavaScript?",
                options: ["To indicate a successful operation", "To represent an invalid number", "To stop a loop", "To declare a function"],
                correctAnswer: "To represent an invalid number",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' object in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To create animations", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype' in JavaScript?",
                options: ["A type of data structure", "A built-in JavaScript function", "An object used for inheritance", "A popular JavaScript library"],
                correctAnswer: "An object used for inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'setTimeout' function in JavaScript?",
                options: ["To define a function", "To execute a function immediately", "To delay the execution of a function", "To create a loop"],
                correctAnswer: "To delay the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the 'async/await' feature used for in JavaScript?",
                options: ["To replace all 'if' statements", "To handle asynchronous code in a more synchronous style", "To define a function", "To create a loop"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'try...catch' statement in JavaScript?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 == '5' in JavaScript?",
                options: ["true", "false", "undefined", "TypeError"],
                correctAnswer: "true",
                category: "JavaScript"
            }
        ],
        '22no': [
            {
                question: "What is the 'call' method used for in JavaScript?",
                options: ["To call a function immediately", "To invoke a function with a specific 'this' value", "To make a network request", "To declare a variable"],
                correctAnswer: "To invoke a function with a specific 'this' value",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage' object in JavaScript?",
                options: ["To store data on a remote server", "To store data temporarily in the browser", "To create animations", "To define CSS styles"],
                correctAnswer: "To store data temporarily in the browser",
                category: "JavaScript"
            },
            {
                question: "What is a 'prototype' in JavaScript?",
                options: ["A type of data structure", "A built-in JavaScript function", "An object used for inheritance", "A popular JavaScript library"],
                correctAnswer: "An object used for inheritance",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'setTimeout' function in JavaScript?",
                options: ["To define a function", "To execute a function immediately", "To delay the execution of a function", "To create a loop"],
                correctAnswer: "To delay the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the 'async/await' feature used for in JavaScript?",
                options: ["To replace all 'if' statements", "To handle asynchronous code in a more synchronous style", "To define a function", "To create a loop"],
                correctAnswer: "To handle asynchronous code in a more synchronous style",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'try...catch' statement in JavaScript?",
                options: ["Creating asynchronous code", "Testing a function", "Handling exceptions and errors", "Defining a new variable"],
                correctAnswer: "Handling exceptions and errors",
                category: "JavaScript"
            },
            {
                question: "What is the result of '5 == '5' in JavaScript?",
                options: ["true", "false", "undefined", "TypeError"],
                correctAnswer: "true",
                category: "JavaScript"
            },
            {
                question: "What does 'ES6' stand for in the context of JavaScript?",
                options: ["Electronic System 6", "Enhanced Scripting 6", "ECMAScript 6", "Elementary Syntax 6"],
                correctAnswer: "ECMAScript 6",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'document.createElement()' method in JavaScript?",
                options: ["To create a new variable", "To define a function", "To select an element by its ID", "To create a new HTML element"],
                correctAnswer: "To create a new HTML element",
                category: "JavaScript"
            },
            {
                question: "What does 'DOM' stand for in JavaScript?",
                options: ["Document Object Model", "Data Object Model", "Desktop Object Model", "Document Over Model"],
                correctAnswer: "Document Object Model",
                category: "JavaScript"
            }
        ],
        '23no': [
            {
                question: "What is the purpose of the 'Object.prototype.hasOwnProperty()' method in JavaScript?",
                options: ["To create a new object", "To check if an object has a specific property", "To modify the original object in place", "To create a prototype chain"],
                correctAnswer: "To check if an object has a specific property",
                category: "JavaScript"
            },
            {
                question: "How is the 'localStorage' different from 'sessionStorage' in JavaScript?",
                options: ["They are the same", "localStorage is permanent, sessionStorage is temporary", "localStorage is temporary, sessionStorage is permanent", "localStorage is read-only"],
                correctAnswer: "localStorage is permanent, sessionStorage is temporary",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.every()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To check if every element in an array passes a test", "To reverse the order of array elements"],
                correctAnswer: "To check if every element in an array passes a test",
                category: "JavaScript"
            },
            {
                question: "How can you convert a number to a string in JavaScript?",
                options: ["number.convertToString()", "String(number)", "number.toString()", "stringify(number)"],
                correctAnswer: "String(number)",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'null == undefined' in JavaScript?",
                options: ["true", "false", "undefined", "null"],
                correctAnswer: "true",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.reverse()' method in JavaScript?",
                options: ["To add an element to the beginning of an array", "To create a new array with the same elements as the original", "To remove the last element from an array", "To reverse the order of array elements"],
                correctAnswer: "To reverse the order of array elements",
                category: "JavaScript"
            },
            {
                question: "What does the 'callee' property refer to in a JavaScript function?",
                options: ["The function itself", "The function's caller", "The function's arguments", "The function's prototype"],
                correctAnswer: "The function itself",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.splice()' method in JavaScript?",
                options: ["To remove elements from an array and, if necessary, insert new elements in their place", "To add an element to the beginning of an array", "To create a new array with the same elements as the original", "To reverse the order of array elements"],
                correctAnswer: "To remove elements from an array and, if necessary, insert new elements in their place",
                category: "JavaScript"
            },
            {
                question: "What does the 'void' operator do in JavaScript?",
                options: ["Makes a variable undefined", "Prevents the execution of a function", "Returns the value of an expression without further evaluation", "Converts a value to a boolean"],
                correctAnswer: "Returns the value of an expression without further evaluation",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Function.prototype.call()' method in JavaScript?",
                options: ["To invoke a function with a specific 'this' value", "To create a new function", "To define a function", "To stop the execution of a function"],
                correctAnswer: "To invoke a function with a specific 'this' value",
                category: "JavaScript"
            }
        ],
        '24no': [
            {
                question: "What is the purpose of the 'Array.prototype.map()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To transform each element in an array using a provided function", "To reverse the order of array elements"],
                correctAnswer: "To transform each element in an array using a provided function",
                category: "JavaScript"
            },
            {
                question: "What does the term 'closure' refer to in JavaScript?",
                options: ["A function with no parameters", "A variable declared outside a function", "A feature for object-oriented programming", "A function that captures its surrounding state"],
                correctAnswer: "A function that captures its surrounding state",
                category: "JavaScript"
            },
            {
                question: "How can you convert a string to a number in JavaScript?",
                options: ["string.convertToNumber()", "Number(string)", "string.toNumber()", "parseNumber(string)"],
                correctAnswer: "Number(string)",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Object.assign()' method in JavaScript?",
                options: ["To create a new object", "To merge multiple objects into one", "To remove properties from an object", "To define a new property on an object"],
                correctAnswer: "To merge multiple objects into one",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'typeof []' in JavaScript?",
                options: ["object", "array", "undefined", "TypeError"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.includes()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To check if an array contains a specific element", "To remove elements from an array", "To reverse the order of array elements"],
                correctAnswer: "To check if an array contains a specific element",
                category: "JavaScript"
            },
            {
                question: "What does the 'debounce' function do in JavaScript?",
                options: ["It adds a delay to the execution of a function", "It removes duplicates from an array", "It converts a string to lowercase", "It creates a new array with the same elements as the original"],
                correctAnswer: "It adds a delay to the execution of a function",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.from()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To convert an array-like or iterable object to an array", "To modify the original array in place", "To reverse the order of array elements"],
                correctAnswer: "To convert an array-like or iterable object to an array",
                category: "JavaScript"
            },
            {
                question: "What is the role of the 'this' keyword in JavaScript arrow functions?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "Arrow functions do not have a 'this' context"],
                correctAnswer: "Arrow functions do not have a 'this' context",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'localStorage.removeItem()' method in JavaScript?",
                options: ["To add an item to the local storage", "To retrieve an item from the local storage", "To clear all items from the local storage", "To remove a specific item from the local storage"],
                correctAnswer: "To remove a specific item from the local storage",
                category: "JavaScript"
            }
        ],
        '25no': [
            {
                question: "What is the purpose of the 'Array.prototype.find()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To find the first element in an array that satisfies a provided testing function", "To reverse the order of array elements"],
                correctAnswer: "To find the first element in an array that satisfies a provided testing function",
                category: "JavaScript"
            },
            {
                question: "What does the term 'hoisting' refer to in JavaScript?",
                options: ["Moving variable declarations to the top of the scope", "Lifting heavy objects in the code", "Creating a new function", "Animating elements on a webpage"],
                correctAnswer: "Moving variable declarations to the top of the scope",
                category: "JavaScript"
            },
            {
                question: "How can you convert a number to a string in JavaScript?",
                options: ["number.convertToString()", "Number.toString()", "stringify(number)", "String(number)"],
                correctAnswer: "String(number)",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Object.keys()' method in JavaScript?",
                options: ["To create a new object", "To retrieve the keys of an object as an array", "To check if an object has a specific property", "To remove properties from an object"],
                correctAnswer: "To retrieve the keys of an object as an array",
                category: "JavaScript"
            },
            {
                question: "What is the result of 'null === undefined' in JavaScript?",
                options: ["true", "false", "undefined", "null"],
                correctAnswer: "false",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.slice()' method in JavaScript?",
                options: ["To add elements to the beginning of an array", "To create a shallow copy of an array", "To remove the last element of an array", "To reverse the order of array elements"],
                correctAnswer: "To create a shallow copy of an array",
                category: "JavaScript"
            },
            {
                question: "What does the 'this' keyword refer to in the context of an object method?",
                options: ["The object itself", "The previous value of the property", "The global object", "The prototype of the object"],
                correctAnswer: "The object itself",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.concat()' method in JavaScript?",
                options: ["To concatenate two or more arrays", "To create a new array with the same elements as the original", "To modify the original array in place", "To reverse the order of array elements"],
                correctAnswer: "To concatenate two or more arrays",
                category: "JavaScript"
            },
            {
                question: "What does the 'typeof' operator return for the 'null' value?",
                options: ["null", "object", "undefined", "string"],
                correctAnswer: "object",
                category: "JavaScript"
            },
            {
                question: "What is the purpose of the 'Array.prototype.forEach()' method in JavaScript?",
                options: ["To create a new array with the same elements as the original", "To modify the original array in place", "To iterate over each element in an array and perform a function", "To reverse the order of array elements"],
                correctAnswer: "To iterate over each element in an array and perform a function",
                category: "JavaScript"
            }
        ]

    },
    HTML: {
        '1no': [
            {
                question: "What does 'HTML' stand for in web development?",
                options: ["Hyper Text Markup Language", "Highly Technical Modern Language", "Hypertext Transfer Language", "Hyperlink and Text Markup Language"],
                correctAnswer: "Hyper Text Markup Language",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define the structure of an HTML document?",
                options: ["<body>", "<head>", "<html>", "<div>"],
                correctAnswer: "<html>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'alt' attribute in an HTML 'img' tag?",
                options: ["To set the image source", "To define the image dimensions", "To specify the image alignment", "To provide alternative text for the image"],
                correctAnswer: "To provide alternative text for the image",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used for creating an ordered list?",
                options: ["<ul>", "<li>", "<ol>", "<dl>"],
                correctAnswer: "<ol>",
                category: "HTML"
            },
            {
                question: "What is the correct HTML element for inserting a line break?",
                options: ["<newline>", "<br>", "<lb>", "<break>"],
                correctAnswer: "<br>",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used for creating a hyperlink?",
                options: ["<link>", "<a>", "<href>", "<hyperlink>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used for creating a table?",
                options: ["<table>", "<tab>", "<tbl>", "<grid>"],
                correctAnswer: "<table>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'DOCTYPE' declaration in an HTML document?",
                options: ["To specify the document type and version of HTML", "To include external JavaScript code", "To define the character encoding of the document", "To style the document using CSS"],
                correctAnswer: "To specify the document type and version of HTML",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define the structure of a web page, including headings, paragraphs, and lists?",
                options: ["<body>", "<head>", "<section>", "<div>"],
                correctAnswer: "<body>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'form' element in HTML?",
                options: ["To create a button", "To define a paragraph", "To create a web form for user input", "To insert an image"],
                correctAnswer: "To create a web form for user input",
                category: "HTML"
            }
        ],
        '2no': [
            {
                question: "What is the purpose of the 'meta' element in HTML?",
                options: ["To define a meta tag", "To specify the document's character encoding and provide metadata", "To create a navigation menu", "To insert an image"],
                correctAnswer: "To specify the document's character encoding and provide metadata",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a numbered list of items?",
                options: ["<list>", "<ol>", "<ul>", "<li>"],
                correctAnswer: "<ol>",
                category: "HTML"
            },
            {
                question: "What does HTML stand for?",
                options: ["Hyper Text Markup Language", "Highly Technical Modern Language", "Hypertext Transfer Language", "Hyperlink and Text Markup Language"],
                correctAnswer: "Hyper Text Markup Language",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used for creating an unordered list?",
                options: ["<ul>", "<li>", "<ol>", "<dl>"],
                correctAnswer: "<ul>",
                category: "HTML"
            },
            {
                question: "What does the 'href' attribute specify in an anchor ('<a>') tag?",
                options: ["The height of the anchor element", "The horizontal position of the anchor element", "The text color of the anchor element", "The URL of the linked resource"],
                correctAnswer: "The URL of the linked resource",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'header' element in HTML?",
                options: ["To define the main heading of a document or section", "To insert a horizontal rule", "To create a list", "To define a hyperlink"],
                correctAnswer: "To define the main heading of a document or section",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define a line break?",
                options: ["<break>", "<lb>", "<newline>", "<br>"],
                correctAnswer: "<br>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'input' element with 'type' attribute set to 'text' in HTML?",
                options: ["To display a text message", "To create a button", "To allow user input for text", "To define a hyperlink"],
                correctAnswer: "To allow user input for text",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a hyperlink?",
                options: ["<link>", "<a>", "<href>", "<hyperlink>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "What does the 'DOCTYPE' declaration in HTML5 specify?",
                options: ["The date the document was created", "The author of the document", "The document type and version", "The document title"],
                correctAnswer: "The document type and version",
                category: "HTML"
            }
        ],
        '3no': [
            {
                question: "What is the purpose of the 'div' element in HTML?",
                options: ["To define a link to an external resource", "To create a hyperlink", "To group and style content", "To display an image"],
                correctAnswer: "To group and style content",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a hyperlink in a new window or tab?",
                options: ["<link>", "<a>", "<a target='_blank'>", "<hyperlink>"],
                correctAnswer: "<a target='_blank'>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'select' element in HTML?",
                options: ["To define a section of text", "To create a drop-down list of options", "To format text as code", "To insert a video"],
                correctAnswer: "To create a drop-down list of options",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to embed audio content in a web page?",
                options: ["<audio>", "<sound>", "<music>", "<embed>"],
                correctAnswer: "<audio>",
                category: "HTML"
            },
            {
                question: "What is the correct HTML tag for creating a hyperlink?",
                options: ["<link>", "<a>", "<href>", "<hyperlink>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "What does the 'src' attribute specify in an 'img' element in HTML?",
                options: ["The image format", "The image description", "The image source URL", "The image dimensions"],
                correctAnswer: "The image source URL",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define a definition list?",
                options: ["<ul>", "<li>", "<ol>", "<dl>"],
                correctAnswer: "<dl>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'footer' element in HTML?",
                options: ["To create a list", "To define the main heading of a document or section", "To insert a horizontal rule", "To provide additional information or copyright details"],
                correctAnswer: "To provide additional information or copyright details",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used for creating a line break without spacing between lines?",
                options: ["<break>", "<lb>", "<newline>", "<br>"],
                correctAnswer: "<br>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'canvas' element in HTML?",
                options: ["To display a text message", "To create animations", "To allow user input for text", "To draw graphics and animations with JavaScript"],
                correctAnswer: "To draw graphics and animations with JavaScript",
                category: "HTML"
            }
        ],
        '4no': [
            {
                question: "What is the purpose of the 'label' element in HTML?",
                options: ["To format text as code", "To provide a caption for a form element", "To define a hyperlink", "To create a table"],
                correctAnswer: "To provide a caption for a form element",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a hyperlink within the same page?",
                options: ["<link>", "<a>", "<href>", "<anchor>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "What is the 'DOCTYPE' declaration used for in HTML?",
                options: ["To specify the document type and version of HTML", "To include external JavaScript code", "To define the character encoding of the document", "To create a hyperlink"],
                correctAnswer: "To specify the document type and version of HTML",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'strong' element in HTML?",
                options: ["To create a section of text", "To define strong emphasis on text", "To format text as bold", "To insert a video"],
                correctAnswer: "To define strong emphasis on text",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a horizontal rule or line across the page?",
                options: ["<line>", "<hr>", "<rule>", "<divider>"],
                correctAnswer: "<hr>",
                category: "HTML"
            },
            {
                question: "What does the 'target' attribute in an anchor ('<a>') tag specify?",
                options: ["The link's URL", "The link's text", "The link's color", "Where to open the linked document"],
                correctAnswer: "Where to open the linked document",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table row?",
                options: ["<row>", "<table>", "<tr>", "<td>"],
                correctAnswer: "<tr>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'cite' element in HTML?",
                options: ["To create citations and references", "To insert a video", "To format text as code", "To define a hyperlink"],
                correctAnswer: "To create citations and references",
                category: "HTML"
            },
            {
                question: "Which HTML element is used for defining the structure of an HTML document, including headings, paragraphs, and lists?",
                options: ["<body>", "<head>", "<section>", "<div>"],
                correctAnswer: "<body>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'iframe' element in HTML?",
                options: ["To create a hyperlink", "To insert a video", "To display another web page within the current page", "To format text as italic"],
                correctAnswer: "To display another web page within the current page",
                category: "HTML"
            }
        ],
        '5no': [
            {
                question: "What is the purpose of the 'fieldset' element in HTML?",
                options: ["To group related form controls", "To define a list of items", "To insert a video", "To create a table"],
                correctAnswer: "To group related form controls",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to define a definition term in a definition list?",
                options: ["<term>", "<define>", "<dt>", "<def>"],
                correctAnswer: "<dt>",
                category: "HTML"
            },
            {
                question: "What does the 'colspan' attribute in an HTML table cell ('<td>') specify?",
                options: ["The column position of the cell", "The cell's color", "The number of columns the cell should span", "The width of the cell"],
                correctAnswer: "The number of columns the cell should span",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'abbr' attribute in an HTML table cell?",
                options: ["To define a hyperlink", "To provide an abbreviation or acronym for the cell content", "To create a row in the table", "To insert a video"],
                correctAnswer: "To provide an abbreviation or acronym for the cell content",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create an ordered list item?",
                options: ["<listitem>", "<ol>", "<ul>", "<li>"],
                correctAnswer: "<li>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'hr' element in HTML?",
                options: ["To format text as code", "To define strong emphasis on text", "To create a horizontal rule or line across the page", "To insert a video"],
                correctAnswer: "To create a horizontal rule or line across the page",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table data cell?",
                options: ["<row>", "<table>", "<tr>", "<td>"],
                correctAnswer: "<td>",
                category: "HTML"
            },
            {
                question: "What does the 'colgroup' element in HTML provide for tables?",
                options: ["It defines a group of table rows", "It defines a group of table columns", "It specifies the font color for table text", "It creates a navigation menu"],
                correctAnswer: "It defines a group of table columns",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'aside' element in HTML?",
                options: ["To define an article or section", "To insert a video", "To create a table", "To provide content that is tangentially related to the content around it"],
                correctAnswer: "To provide content that is tangentially related to the content around it",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define a thematic break or a separation between content?",
                options: ["<linebreak>", "<section>", "<div>", "<hr>"],
                correctAnswer: "<hr>",
                category: "HTML"
            }
        ],
        '6no': [
            {
                question: "What is the purpose of the 'figcaption' element in HTML?",
                options: ["To create a hyperlink", "To define a list of items", "To insert a video", "To provide a caption for a <figure> element"],
                correctAnswer: "To provide a caption for a <figure> element",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a hyperlink that points to an email address?",
                options: ["<email>", "<mailto>", "<a>", "<href>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "What does the 'rel' attribute in an anchor ('<a>') tag specify in HTML?",
                options: ["The link's URL", "The link's color", "The relationship between the current document and the linked document", "The link's text"],
                correctAnswer: "The relationship between the current document and the linked document",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a navigation menu?",
                options: ["<nav>", "<menu>", "<ul>", "<list>"],
                correctAnswer: "<nav>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'figure' element in HTML?",
                options: ["To define a link to an external resource", "To create a hyperlink", "To group content that is related", "To encapsulate content, typically with an image and a caption"],
                correctAnswer: "To encapsulate content, typically with an image and a caption",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a subscript text?",
                options: ["<sub>", "<sup>", "<subscript>", "<text>"],
                correctAnswer: "<sub>",
                category: "HTML"
            },
            {
                question: "What does the 'download' attribute in an anchor ('<a>') tag specify in HTML?",
                options: ["The link's URL", "The link's text", "The relationship between the current document and the linked document", "The name for the downloaded file"],
                correctAnswer: "The name for the downloaded file",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a tooltip or additional information for an element?",
                options: ["<info>", "<tooltip>", "<title>", "<abbr>"],
                correctAnswer: "<abbr>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'main' element in HTML?",
                options: ["To define an article or section", "To create a hyperlink", "To create a table", "To represent the main content of the document"],
                correctAnswer: "To represent the main content of the document",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a citation or reference to another source?",
                options: ["<source>", "<citation>", "<cite>", "<ref>"],
                correctAnswer: "<cite>",
                category: "HTML"
            }
        ],
        '7no': [
            {
                question: "What is the purpose of the 'time' element in HTML?",
                options: ["To specify the document's character encoding and provide metadata", "To define a hyperlink", "To create a timestamp or date", "To create a table"],
                correctAnswer: "To create a timestamp or date",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a superscript text?",
                options: ["<sup>", "<sub>", "<super>", "<text>"],
                correctAnswer: "<sup>",
                category: "HTML"
            },
            {
                question: "What does the 'async' attribute do when applied to a script element in HTML?",
                options: ["It specifies the document type", "It indicates that the script should be executed asynchronously", "It defines the character encoding of the document", "It creates a hyperlink"],
                correctAnswer: "It indicates that the script should be executed asynchronously",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a button?",
                options: ["<btn>", "<button>", "<input type='button'>", "<create-button>"],
                correctAnswer: "<button>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'small' element in HTML?",
                options: ["To create a hyperlink", "To provide a caption for a <figure> element", "To format text as small", "To insert a video"],
                correctAnswer: "To format text as small",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a variable or placeholder for data that will be inserted using JavaScript?",
                options: ["<var>", "<placeholder>", "<data>", "<script>"],
                correctAnswer: "<var>",
                category: "HTML"
            },
            {
                question: "What does the 'list' attribute in an 'input' element specify in HTML?",
                options: ["The input's type", "The list of available options for a dropdown", "The input's name", "The input's list of valid values"],
                correctAnswer: "The input's list of valid values",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a definition description in a definition list?",
                options: ["<description>", "<define>", "<dd>", "<desc>"],
                correctAnswer: "<dd>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'menu' element in HTML?",
                options: ["To create a navigation menu", "To define an article or section", "To create a table", "To provide a caption for a form element"],
                correctAnswer: "To create a navigation menu",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a block of code in a document?",
                options: ["<block>", "<code>", "<pre>", "<text>"],
                correctAnswer: "<code>",
                category: "HTML"
            }
        ],
        '8no': [
            {
                question: "What is the purpose of the 'article' element in HTML?",
                options: ["To create a hyperlink", "To represent a self-contained piece of content", "To create a table", "To define an ordered list"],
                correctAnswer: "To represent a self-contained piece of content",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to define a block of preformatted text?",
                options: ["<block>", "<pre>", "<code>", "<text>"],
                correctAnswer: "<pre>",
                category: "HTML"
            },
            {
                question: "What does the 'autocomplete' attribute in an 'input' element specify in HTML?",
                options: ["The input's type", "The input's name", "Whether the browser should provide automatic suggestions for input", "The input's list of valid values"],
                correctAnswer: "Whether the browser should provide automatic suggestions for input",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table header cell?",
                options: ["<header>", "<th>", "<hd>", "<table-header>"],
                correctAnswer: "<th>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'blockquote' element in HTML?",
                options: ["To create a hyperlink", "To format text as a block quote", "To insert a video", "To define a table"],
                correctAnswer: "To format text as a block quote",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create an ordered list item?",
                options: ["<listitem>", "<ol>", "<ul>", "<li>"],
                correctAnswer: "<li>",
                category: "HTML"
            },
            {
                question: "What does the 'controls' attribute in an 'audio' element do in HTML?",
                options: ["It specifies the document type", "It indicates whether audio controls should be displayed", "It defines the character encoding of the document", "It creates a hyperlink"],
                correctAnswer: "It indicates whether audio controls should be displayed",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table data cell that spans multiple rows?",
                options: ["<rowspan>", "<table>", "<tr>", "<td>"],
                correctAnswer: "<td rowspan='n'>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'samp' element in HTML?",
                options: ["To create a section of text", "To provide sample or code output", "To format text as italic", "To insert a video"],
                correctAnswer: "To provide sample or code output",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a placeholder for an image or other media content?",
                options: ["<media>", "<image>", "<placeholder>", "<embed>"],
                correctAnswer: "<placeholder>",
                category: "HTML"
            }
        ],
        '9no': [
            {
                question: "What is the purpose of the 'nav' element in HTML?",
                options: ["To define a section of text", "To create a navigation menu", "To format text as code", "To insert a video"],
                correctAnswer: "To create a navigation menu",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a clickable button in a form?",
                options: ["<button>", "<input type='button'>", "<submit>", "<clickable>"],
                correctAnswer: "<button>",
                category: "HTML"
            },
            {
                question: "What does the 'download' attribute in an anchor ('<a>') tag specify in HTML?",
                options: ["The link's URL", "The link's text", "The relationship between the current document and the linked document", "The name for the downloaded file"],
                correctAnswer: "The name for the downloaded file",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create an unordered list item?",
                options: ["<listitem>", "<ul>", "<ol>", "<li>"],
                correctAnswer: "<li>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'q' element in HTML?",
                options: ["To define a quote or citation", "To insert a video", "To create a table", "To provide a caption for a form element"],
                correctAnswer: "To define a quote or citation",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a block of code in a document?",
                options: ["<code>", "<block>", "<pre>", "<text>"],
                correctAnswer: "<code>",
                category: "HTML"
            },
            {
                question: "What does the 'rows' attribute in an HTML table specify?",
                options: ["The number of table columns", "The font size for table text", "The table's background color", "The number of visible rows in the table"],
                correctAnswer: "The number of visible rows in the table",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table header cell?",
                options: ["<header>", "<th>", "<hd>", "<table-header>"],
                correctAnswer: "<th>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'aside' element in HTML?",
                options: ["To define a list of items", "To insert a video", "To create a table", "To provide content that is tangentially related to the content around it"],
                correctAnswer: "To provide content that is tangentially related to the content around it",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a navigation menu in a sidebar or additional content section?",
                options: ["<menu>", "<nav>", "<list>", "<sidebar>"],
                correctAnswer: "<menu>",
                category: "HTML"
            }
        ],
        '10no': [
            {
                question: "What is the purpose of the 'mark' element in HTML?",
                options: ["To define a hyperlink", "To format text as code", "To highlight text within the content", "To insert a video"],
                correctAnswer: "To highlight text within the content",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a strikethrough text?",
                options: ["<strike>", "<strikethrough>", "<del>", "<s>"],
                correctAnswer: "<del>",
                category: "HTML"
            },
            {
                question: "What does the 'scope' attribute in an 'th' element specify in an HTML table?",
                options: ["The table's background color", "The header cell's content", "The number of columns the header cell covers", "The type of data in the table cell"],
                correctAnswer: "The number of columns the header cell covers",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create an ordered list?",
                options: ["<list>", "<ol>", "<ul>", "<li>"],
                correctAnswer: "<ol>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'time' element in HTML?",
                options: ["To create a section of text", "To specify a timestamp or date", "To create a table", "To define an article or section"],
                correctAnswer: "To specify a timestamp or date",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a hyperlink to a specific section within the same page?",
                options: ["<link>", "<a>", "<href>", "<anchor>"],
                correctAnswer: "<a href='#section'>",
                category: "HTML"
            },
            {
                question: "What does the 'datetime' attribute in the 'time' element specify in HTML?",
                options: ["The document type", "The current date and time", "The format of the timestamp", "The date and time for the content"],
                correctAnswer: "The date and time for the content",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create an unordered list item?",
                options: ["<listitem>", "<ul>", "<ol>", "<li>"],
                correctAnswer: "<li>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'datalist' element in HTML?",
                options: ["To create a list of options for a dropdown", "To insert a video", "To define a hyperlink", "To provide a caption for a form element"],
                correctAnswer: "To create a list of options for a dropdown",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a clickable image or graphical element?",
                options: ["<img>", "<clickable>", "<graphic>", "<picture>"],
                correctAnswer: "<img>",
                category: "HTML"
            }
        ],
        '11no': [
            {
                question: "What is the purpose of the 'abbr' element in HTML?",
                options: ["To create a hyperlink", "To provide an abbreviation or acronym for the content", "To insert a video", "To define a table"],
                correctAnswer: "To provide an abbreviation or acronym for the content",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a subscript text?",
                options: ["<sub>", "<sup>", "<subscript>", "<text>"],
                correctAnswer: "<sub>",
                category: "HTML"
            },
            {
                question: "What does the 'download' attribute in an anchor ('<a>') tag specify in HTML?",
                options: ["The link's URL", "The link's text", "The relationship between the current document and the linked document", "The name for the downloaded file"],
                correctAnswer: "The name for the downloaded file",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a tooltip or additional information for an element?",
                options: ["<info>", "<tooltip>", "<title>", "<abbr>"],
                correctAnswer: "<abbr>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'main' element in HTML?",
                options: ["To define an article or section", "To create a hyperlink", "To create a table", "To represent the main content of the document"],
                correctAnswer: "To represent the main content of the document",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define a thematic break or a separation between content?",
                options: ["<linebreak>", "<section>", "<div>", "<hr>"],
                correctAnswer: "<hr>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'figcaption' element in HTML?",
                options: ["To create a hyperlink", "To define a list of items", "To insert a video", "To provide a caption for a <figure> element"],
                correctAnswer: "To provide a caption for a <figure> element",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to create a hyperlink that points to an email address?",
                options: ["<email>", "<mailto>", "<a>", "<href>"],
                correctAnswer: "<a>",
                category: "HTML"
            },
            {
                question: "What does the 'rel' attribute in an anchor ('<a>') tag specify in HTML?",
                options: ["The link's URL", "The link's color", "The relationship between the current document and the linked document", "The link's text"],
                correctAnswer: "The relationship between the current document and the linked document",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a navigation menu?",
                options: ["<nav>", "<menu>", "<ul>", "<list>"],
                correctAnswer: "<nav>",
                category: "HTML"
            }
        ],
        '12no': [
            {
                question: "What is the purpose of the 'article' element in HTML?",
                options: ["To create a hyperlink", "To represent a self-contained piece of content", "To create a table", "To define an ordered list"],
                correctAnswer: "To represent a self-contained piece of content",
                category: "HTML"
            },
            {
                question: "Which HTML tag is used to define a block of preformatted text?",
                options: ["<block>", "<pre>", "<code>", "<text>"],
                correctAnswer: "<pre>",
                category: "HTML"
            },
            {
                question: "What does the 'autocomplete' attribute in an 'input' element specify in HTML?",
                options: ["The input's type", "The input's name", "Whether the browser should provide automatic suggestions for input", "The input's list of valid values"],
                correctAnswer: "Whether the browser should provide automatic suggestions for input",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table header cell?",
                options: ["<header>", "<th>", "<hd>", "<table-header>"],
                correctAnswer: "<th>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'blockquote' element in HTML?",
                options: ["To create a hyperlink", "To format text as a block quote", "To insert a video", "To define a table"],
                correctAnswer: "To format text as a block quote",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create an ordered list item?",
                options: ["<listitem>", "<ol>", "<ul>", "<li>"],
                correctAnswer: "<li>",
                category: "HTML"
            },
            {
                question: "What does the 'controls' attribute in an 'audio' element do in HTML?",
                options: ["It specifies the document type", "It indicates whether audio controls should be displayed", "It defines the character encoding of the document", "It creates a hyperlink"],
                correctAnswer: "It indicates whether audio controls should be displayed",
                category: "HTML"
            },
            {
                question: "In HTML, which tag is used to create a table data cell that spans multiple rows?",
                options: ["<rowspan>", "<table>", "<tr>", "<td>"],
                correctAnswer: "<td rowspan='n'>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'samp' element in HTML?",
                options: ["To create a section of text", "To provide sample or code output", "To format text as italic", "To insert a video"],
                correctAnswer: "To provide sample or code output",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a placeholder for an image or other media content?",
                options: ["<media>", "<image>", "<placeholder>", "<embed>"],
                correctAnswer: "<placeholder>",
                category: "HTML"
            }
        ],
        '13no': [
            {
                question: "What does the 'figure' element in HTML typically enclose?",
                options: ["An image or illustration", "A code block", "A navigation menu", "A table"],
                correctAnswer: "An image or illustration",
                category: "HTML"
            },
            {
                question: "In HTML, what does the 'sandbox' attribute do when used with iframes?",
                options: ["It restricts the iframe's content from executing scripts", "It changes the iframe's border color", "It resizes the iframe", "It makes the iframe fullscreen"],
                correctAnswer: "It restricts the iframe's content from executing scripts",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to define a section within an HTML document?",
                options: ["<section>", "<div>", "<block>", "<content>"],
                correctAnswer: "<section>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'meter' element in HTML?",
                options: ["To define a hyperlink", "To measure the bandwidth of a website", "To display a scalar measurement within a known range", "To create a table"],
                correctAnswer: "To display a scalar measurement within a known range",
                category: "HTML"
            },
            {
                question: "In HTML, what is the 'colspan' attribute used for in a table cell ('<td>')?",
                options: ["To set the background color of the cell", "To define the number of rows the cell spans", "To specify the type of data in the cell", "To create a hyperlink"],
                correctAnswer: "To define the number of columns the cell spans",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to embed audio content on a web page?",
                options: ["<audio>", "<sound>", "<music>", "<play>"],
                correctAnswer: "<audio>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'samp' element in HTML?",
                options: ["To create a section of text", "To provide sample or code output", "To format text as italic", "To insert a video"],
                correctAnswer: "To provide sample or code output",
                category: "HTML"
            },
            {
                question: "In HTML, what does the 'form' element typically contain?",
                options: ["Text content and images", "Interactive form controls and input fields", "Links to other web pages", "A list of items"],
                correctAnswer: "Interactive form controls and input fields",
                category: "HTML"
            },
            {
                question: "Which HTML element is used to create a subscript text?",
                options: ["<sub>", "<sup>", "<subscript>", "<text>"],
                correctAnswer: "<sub>",
                category: "HTML"
            },
            {
                question: "What is the purpose of the 'wbr' element in HTML?",
                options: ["To create a hyperlink", "To insert a video", "To define a line break opportunity within text", "To format text as bold"],
                correctAnswer: "To define a line break opportunity within text",
                category: "HTML"
            }
        ]
    },
    CSS: {
        '1no': [
            {
                question: "What does CSS stand for?",
                options: ["Cascading Style Sheet", "Computer Style Sheet", "Creative Style Sheet", "Colorful Style Sheet"],
                correctAnswer: "Cascading Style Sheet",
                category: "CSS"
            },
            {
                question: "Which property is used to change the background color of an element in CSS?",
                options: ["color", "background-color", "text-color", "fill-color"],
                correctAnswer: "background-color",
                category: "CSS"
            },
            {
                question: "What is the CSS box model used for?",
                options: ["Styling fonts", "Creating animations", "Defining layout and spacing of elements", "Handling AJAX requests"],
                correctAnswer: "Defining layout and spacing of elements",
                category: "CSS"
            },
            {
                question: "What CSS property is used to make text bold?",
                options: ["font-weight", "text-style", "font-bold", "font-enhance"],
                correctAnswer: "font-weight",
                category: "CSS"
            },
            {
                question: "How can you select all paragraph elements with class 'highlight' in CSS?",
                options: [".highlight p", "p.highlight", "#highlight p", ".p.highlight"],
                correctAnswer: "p.highlight",
                category: "CSS"
            },
            {
                question: "What CSS property is used to set the text color of an element?",
                options: ["color", "text-color", "font-color", "text-style"],
                correctAnswer: "color",
                category: "CSS"
            },
            {
                question: "In CSS, what is the purpose of the 'display' property?",
                options: ["To change the text font", "To hide elements", "To define the positioning of an element", "To set how an element is displayed"],
                correctAnswer: "To set how an element is displayed",
                category: "CSS"
            },
            {
                question: "Which CSS property is used to control the size of an element's margin outside its border?",
                options: ["padding", "spacing", "border-width", "margin"],
                correctAnswer: "margin",
                category: "CSS"
            },
            {
                question: "What is the CSS 'float' property used for?",
                options: ["To add shadows to elements", "To position elements side by side", "To make text italic", "To create gradients"],
                correctAnswer: "To position elements side by side",
                category: "CSS"
            },
            {
                question: "Which CSS selector is used to select elements with a specific class name?",
                options: ["#", ".", "&", "@"],
                correctAnswer: ".",
                category: "CSS"
            }
        ],
        '2no': [
            {
                question: "What does the CSS property 'text-decoration: underline' do?",
                options: ["Makes text bold", "Adds an underline to the text", "Changes the font of the text", "Sets the text color"],
                correctAnswer: "Adds an underline to the text",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'z-index' property in CSS?",
                options: ["To set the background color of an element", "To control the stacking order of elements", "To create text animations", "To style fonts"],
                correctAnswer: "To control the stacking order of elements",
                category: "CSS"
            },
            {
                question: "Which CSS property is used to add space between the border and content of an element?",
                options: ["margin", "padding", "spacing", "border-spacing"],
                correctAnswer: "padding",
                category: "CSS"
            },
            {
                question: "What is the 'box-sizing' property in CSS used for?",
                options: ["To define the shape of an element", "To set the box model to 'border-box' or 'content-box'", "To add shadows to an element", "To change text alignment"],
                correctAnswer: "To set the box model to 'border-box' or 'content-box'",
                category: "CSS"
            },
            {
                question: "What does the CSS 'position: relative' property do?",
                options: ["Makes an element disappear", "Positions an element relative to its normal position", "Changes the font of the element", "Hides text"],
                correctAnswer: "Positions an element relative to its normal position",
                category: "CSS"
            },
            {
                question: "What is the CSS property 'overflow' used for?",
                options: ["To hide an element", "To create borders around an element", "To control how content overflows its container", "To change the text color"],
                correctAnswer: "To control how content overflows its container",
                category: "CSS"
            },
            {
                question: "What does 'CSS' in 'CSS Flexbox' stand for?",
                options: ["Cascading Style Sheet", "Centered Style Sheet", "Content Style Sheet", "Comprehensive Style Sheet"],
                correctAnswer: "Cascading Style Sheet",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'text-align' property in CSS?",
                options: ["To set the text font", "To add shadows to text", "To control the alignment of text within an element", "To change the text color"],
                correctAnswer: "To control the alignment of text within an element",
                category: "CSS"
            },
            {
                question: "What is the CSS 'opacity' property used for?",
                options: ["To make an element invisible", "To set the background color of an element", "To add an underline to text", "To create gradients"],
                correctAnswer: "To make an element invisible",
                category: "CSS"
            },
            {
                question: "In CSS, what is the purpose of the 'transform' property?",
                options: ["To change text alignment", "To create animations and apply 2D or 3D transformations to elements", "To define the size of an element", "To control the stacking order of elements"],
                correctAnswer: "To create animations and apply 2D or 3D transformations to elements",
                category: "CSS"
            }
        ],
        '3no': [
            {
                question: "What is the CSS 'box-shadow' property used for?",
                options: ["To set the background color of an element", "To add a shadow around an element", "To create text animations", "To define font style"],
                correctAnswer: "To add a shadow around an element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'text-transform: uppercase' property do?",
                options: ["Makes text bold", "Adds italics to text", "Converts text to uppercase", "Changes the font of the text"],
                correctAnswer: "Converts text to uppercase",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'line-height' property in CSS?",
                options: ["To set the font size", "To control the space between lines of text", "To create text animations", "To change text alignment"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-radius' property define?",
                options: ["The width of an element's border", "The rounded corners of an element", "The opacity of an element", "The border color of an element"],
                correctAnswer: "The rounded corners of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'cursor' property in CSS?",
                options: ["To hide the mouse cursor", "To define the font style", "To specify the type of cursor to be displayed when hovering over an element", "To add shadows to elements"],
                correctAnswer: "To specify the type of cursor to be displayed when hovering over an element",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-class' refer to?",
                options: ["A class name starting with 'Pseudo'", "A class with no styles", "A keyword used to select a specific state or element", "A type of font style"],
                correctAnswer: "A keyword used to select a specific state or element",
                category: "CSS"
            },
            {
                question: "What is the 'display: flex' property in CSS used for?",
                options: ["To change text alignment", "To position elements side by side in a flex container", "To define the size of an element", "To create animations"],
                correctAnswer: "To position elements side by side in a flex container",
                category: "CSS"
            },
            {
                question: "What is the 'CSS Grid' used for in web development?",
                options: ["To set the background color of a page", "To create a grid layout for arranging elements", "To style fonts", "To hide text"],
                correctAnswer: "To create a grid layout for arranging elements",
                category: "CSS"
            },
            {
                question: "What does the CSS 'background-image' property allow you to do?",
                options: ["To add a background color to an element", "To add a background image to an element", "To define font style", "To hide elements"],
                correctAnswer: "To add a background image to an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'media queries' in CSS?",
                options: ["To play media files", "To specify different styles for different devices or screen sizes", "To create animations", "To control the opacity of elements"],
                correctAnswer: "To specify different styles for different devices or screen sizes",
                category: "CSS"
            }
        ],
        '4no': [
            {
                question: "What does the CSS 'position: absolute' property do?",
                options: ["Makes an element invisible", "Positions an element absolutely within its nearest positioned ancestor", "Defines the size of an element", "Hides an element"],
                correctAnswer: "Positions an element absolutely within its nearest positioned ancestor",
                category: "CSS"
            },
            {
                question: "What is the 'CSS specificity' used for?",
                options: ["To determine the importance of CSS rules when multiple rules apply to an element", "To change text alignment", "To define font style", "To create gradients"],
                correctAnswer: "To determine the importance of CSS rules when multiple rules apply to an element",
                category: "CSS"
            },
            {
                question: "What is the CSS 'text-overflow' property used for?",
                options: ["To add shadows to text", "To make text bold", "To control text when it overflows its containing element", "To create animations"],
                correctAnswer: "To control text when it overflows its containing element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'opacity' property accept as values?",
                options: ["Only 'visible' and 'hidden'", "Only numbers from 0 to 100", "Only integers", "Numbers from 0 to 1"],
                correctAnswer: "Numbers from 0 to 1",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' refer to?",
                options: ["A type of font style", "A way to select elements in the DOM based on their tag or class names", "A type of cursor", "A method to change the text color"],
                correctAnswer: "A way to select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "In CSS, what is 'transformation' used for?",
                options: ["To define the size of an element", "To create animations and apply 2D or 3D transformations to elements", "To control the stacking order of elements", "To position elements side by side"],
                correctAnswer: "To create animations and apply 2D or 3D transformations to elements",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To control the stacking order of elements", "To create animations when a CSS property changes", "To create a gradient background", "To set the text color"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the CSS 'overflow: hidden' property do?",
                options: ["Makes an element invisible", "Hides overflowing content of an element", "Defines the size of an element", "Sets the background color of an element"],
                correctAnswer: "Hides overflowing content of an element",
                category: "CSS"
            },
            {
                question: "What is the 'CSS pseudo-element' used for?",
                options: ["To define the font style of a specific element", "To select elements based on their class names", "To style parts of an element, like the first line of a paragraph", "To change the opacity of elements"],
                correctAnswer: "To style parts of an element, like the first line of a paragraph",
                category: "CSS"
            },
            {
                question: "What is the CSS 'flex-direction' property used for?",
                options: ["To create animations", "To control the alignment of text within an element", "To position elements side by side in a flex container", "To set the background color of a page"],
                correctAnswer: "To position elements side by side in a flex container",
                category: "CSS"
            }
        ],
        '5no': [
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What does the 'box-sizing' property value 'border-box' mean in CSS?",
                options: ["The width and height of the element include padding and border", "The width and height of the element include only content", "The width and height of the element include only margin", "The width and height of the element include all properties"],
                correctAnswer: "The width and height of the element include padding and border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'flex-wrap' property?",
                options: ["To wrap text within an element", "To determine the direction of text", "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines", "To change the font style"],
                correctAnswer: "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ],
        '6no': [
            {
                question: "What is the CSS 'box-sizing' property used for?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's box model", "To create text animations", "To define font style"],
                correctAnswer: "To control the sizing behavior of an element's box model",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'position: relative' property?",
                options: ["To create animations", "To make an element disappear", "To change text alignment", "To position an element relative to its normal position"],
                correctAnswer: "To position an element relative to its normal position",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'max-width' property control?",
                options: ["The maximum width of an element", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The maximum width of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transform' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To apply two-dimensional or three-dimensional transformations to an element"],
                correctAnswer: "To apply two-dimensional or three-dimensional transformations to an element",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '::before' represent?",
                options: ["The first child element of an element", "An element's margin area", "An element's before content", "All elements with a specific class name"],
                correctAnswer: "An element's before content",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: absolute' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element absolutely within its nearest positioned ancestor",
                category: "CSS"
            }
        ],
        '7no': [
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the CSS 'box-shadow' property used for?",
                options: ["To set the background color of an element", "To add a shadow around an element", "To create text animations", "To define font style"],
                correctAnswer: "To add a shadow around an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'flex-wrap' property?",
                options: ["To wrap text within an element", "To determine the direction of text", "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines", "To change the font style"],
                correctAnswer: "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ],
        '8no': [
            {
                question: "What is the CSS 'flex-grow' property used for?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's box model", "To define the growth factor of a flex item", "To create text animations"],
                correctAnswer: "To define the growth factor of a flex item",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'clear' property?",
                options: ["To create animations", "To clear the floated elements on both sides of an element", "To change text alignment", "To position an element relative to its normal position"],
                correctAnswer: "To clear the floated elements on both sides of an element",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'max-height' property control?",
                options: ["The maximum height of an element", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The maximum height of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS animation' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To apply animations to an element"],
                correctAnswer: "To apply animations to an element",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '::after' represent?",
                options: ["The last child element of an element", "An element's padding area", "An element's after content", "All elements with a specific class name"],
                correctAnswer: "An element's after content",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: static' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element according to the normal flow of the document"],
                correctAnswer: "To position an element according to the normal flow of the document",
                category: "CSS"
            }
        ],
        '9no': [
            {
                question: "What is the CSS 'float' property used for?",
                options: ["To change the text color", "To control the stacking order of elements", "To create animations", "To specify how an element should float within its parent element"],
                correctAnswer: "To specify how an element should float within its parent element",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'flex-wrap' property?",
                options: ["To wrap text within an element", "To determine the direction of text", "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines", "To change the font style"],
                correctAnswer: "To control whether flex items are forced onto a single line or allowed to wrap onto multiple lines",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ],
        '10no': [
            {
                question: "What is the CSS 'grid-template-columns' property used for?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's box model", "To define the columns in a grid layout", "To create text animations"],
                correctAnswer: "To define the columns in a grid layout",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'transition' property?",
                options: ["To create animations", "To smoothly animate changes in CSS properties", "To change text alignment", "To position an element relative to its normal position"],
                correctAnswer: "To smoothly animate changes in CSS properties",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'min-width' property control?",
                options: ["The minimum width of an element", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The minimum width of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transform-origin' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To set the origin point for CSS transformations"],
                correctAnswer: "To set the origin point for CSS transformations",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':nth-child(odd)' select?",
                options: ["All elements", "Even-numbered child elements", "Odd-numbered child elements", "Elements with a specific class name"],
                correctAnswer: "Odd-numbered child elements",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: sticky' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To make an element stick to the viewport when scrolling"],
                correctAnswer: "To make an element stick to the viewport when scrolling",
                category: "CSS"
            }
        ],
        '11no': [
            {
                question: "What is the purpose of the CSS 'flex-shrink' property?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's box model", "To define the shrinking factor of a flex item", "To create text animations"],
                correctAnswer: "To define the shrinking factor of a flex item",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'object-fit' property?",
                options: ["To create animations", "To control the sizing behavior of an element's content", "To change text alignment", "To position an element relative to its normal position"],
                correctAnswer: "To control the sizing behavior of an element's content",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'min-height' property control?",
                options: ["The minimum height of an element", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The minimum height of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS perspective' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create a 3D effect on transformed elements"],
                correctAnswer: "To create a 3D effect on transformed elements",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':nth-child(even)' select?",
                options: ["All elements", "Even-numbered child elements", "Odd-numbered child elements", "Elements with a specific class name"],
                correctAnswer: "Even-numbered child elements",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: sticky' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To make an element stick to the viewport when scrolling"],
                correctAnswer: "To make an element stick to the viewport when scrolling",
                category: "CSS"
            }
        ],
        '12no': [
            {
                question: "What is the CSS 'flex-basis' property used for?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's box model", "To define the initial size of a flex item", "To create text animations"],
                correctAnswer: "To define the initial size of a flex item",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'word-wrap' property?",
                options: ["To create animations", "To control the sizing behavior of an element's text content", "To change text alignment", "To wrap long words to the next line"],
                correctAnswer: "To wrap long words to the next line",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-radius' property control?",
                options: ["The transparency of an element", "The opacity of an element", "The rounded corners of an element", "The font size"],
                correctAnswer: "The rounded corners of an element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS calc()' function?",
                options: ["To create animations", "To perform calculations within a CSS property value", "To change text alignment", "To apply styles based on user interactions"],
                correctAnswer: "To perform calculations within a CSS property value",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':first-child' select?",
                options: ["All elements", "The first child element of its parent", "The last child element of its parent", "Elements with a specific class name"],
                correctAnswer: "The first child element of its parent",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: sticky' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To make an element stick to the viewport when scrolling"],
                correctAnswer: "To make an element stick to the viewport when scrolling",
                category: "CSS"
            }
        ],
        '13no': [
            {
                question: "What is the CSS 'mix-blend-mode' property used for?",
                options: ["To set the background color of an element", "To control the blending mode of an element with its background", "To define the initial size of a flex item", "To create text animations"],
                correctAnswer: "To control the blending mode of an element with its background",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'pointer-events' property?",
                options: ["To create animations", "To control the sizing behavior of an element's box model", "To change text alignment", "To control whether an element can be the target for pointer events"],
                correctAnswer: "To control whether an element can be the target for pointer events",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'letter-spacing' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between characters in text"],
                correctAnswer: "To control the space between characters in text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'background-position' property control?",
                options: ["The position of an element's background image", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The position of an element's background image",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS content' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To insert generated content before or after an element's content"],
                correctAnswer: "To insert generated content before or after an element's content",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':last-child' select?",
                options: ["All elements", "The first child element of its parent", "The last child element of its parent", "Elements with a specific class name"],
                correctAnswer: "The last child element of its parent",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: sticky' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To make an element stick to the viewport when scrolling"],
                correctAnswer: "To make an element stick to the viewport when scrolling",
                category: "CSS"
            }
        ],
        '14no': [
            {
                question: "What is the CSS 'grid-template-rows' property used for?",
                options: ["To set the background color of an element", "To control the sizing behavior of an element's grid rows", "To define the initial size of a flex item", "To create text animations"],
                correctAnswer: "To control the sizing behavior of an element's grid rows",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'object-fit' property?",
                options: ["To create animations", "To control the sizing behavior of replaced elements", "To change text alignment", "To specify how nested elements should be rendered in 3D space"],
                correctAnswer: "To control the sizing behavior of replaced elements",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'text-decoration' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the decoration of text, such as underline or strikethrough"],
                correctAnswer: "To control the decoration of text, such as underline or strikethrough",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'flex-shrink' property control?",
                options: ["The opacity of an element", "The ability of a flex item to shrink if necessary", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The ability of a flex item to shrink if necessary",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS perspective-origin' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To set the origin point for CSS 3D transformations"],
                correctAnswer: "To set the origin point for CSS 3D transformations",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':disabled' select?",
                options: ["All elements", "Elements with content", "Elements with a specific class name", "Disabled form elements"],
                correctAnswer: "Disabled form elements",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: absolute' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element absolutely within its nearest positioned ancestor",
                category: "CSS"
            }
        ],
        '15no': [
            {
                question: "What is the CSS 'justify-content' property used for?",
                options: ["To set the background color of an element", "To control the alignment of flex items along the main axis", "To define the initial size of a flex item", "To create text animations"],
                correctAnswer: "To control the alignment of flex items along the main axis",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'opacity' property?",
                options: ["To create animations", "To control the sizing behavior of an element's box model", "To change text alignment", "To adjust the transparency of an element"],
                correctAnswer: "To adjust the transparency of an element",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'box-decoration-break' property control?",
                options: ["The transparency of an element", "The space between an element's border and its content", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "The space between an element's border and its content",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transform-origin' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To set the point around which a transformation should occur"],
                correctAnswer: "To set the point around which a transformation should occur",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' ':checked' select?",
                options: ["All elements", "Checked input elements", "Unchecked input elements", "Elements with a specific class name"],
                correctAnswer: "Checked input elements",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport, staying in place even during scrolling"],
                correctAnswer: "To position an element relative to the viewport, staying in place even during scrolling",
                category: "CSS"
            }
        ],
        '16no': [
            {
                question: "What is the CSS 'z-index' property used for?",
                options: ["To change text color", "To control the stacking order of elements", "To create animations", "To specify font style"],
                correctAnswer: "To control the stacking order of elements",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'display' property?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To control how an element is displayed in the layout"],
                correctAnswer: "To control how an element is displayed in the layout",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ],
        '17no': [
            {
                question: "What is the CSS 'opacity' property used for?",
                options: ["To set the background color of an element", "To control the stacking order of elements", "To make an element invisible or semi-transparent", "To specify font style"],
                correctAnswer: "To make an element invisible or semi-transparent",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'display' property?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To control how an element is displayed in the layout"],
                correctAnswer: "To control how an element is displayed in the layout",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ],
        '18no': [
            {
                question: "What is the CSS 'pseudo-class' :hover used for?",
                options: ["To select elements that are being clicked", "To style elements when the mouse is over them", "To define font style", "To create animations"],
                correctAnswer: "To style elements when the mouse is over them",
                category: "CSS"
            },
            {
                question: "What does the 'CSS specificity' of a selector determine?",
                options: ["The size of a CSS file", "The order in which styles are applied to an element", "The importance of a CSS rule when multiple rules target the same element", "The width of an element"],
                correctAnswer: "The importance of a CSS rule when multiple rules target the same element",
                category: "CSS"
            },
            {
                question: "What is the purpose of the CSS 'display' property?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To control how an element is displayed in the layout"],
                correctAnswer: "To control how an element is displayed in the layout",
                category: "CSS"
            },
            {
                question: "What is the 'CSS selector' used for?",
                options: ["To create animations", "To select elements in the DOM based on their tag or class names", "To define font style", "To change the opacity of elements"],
                correctAnswer: "To select elements in the DOM based on their tag or class names",
                category: "CSS"
            },
            {
                question: "What is the CSS 'line-height' property used for?",
                options: ["To set the font size", "To create animations", "To define the size of an element", "To control the space between lines of text"],
                correctAnswer: "To control the space between lines of text",
                category: "CSS"
            },
            {
                question: "In CSS, what does 'Pseudo-element' refer to?",
                options: ["A keyword used to select elements with a specific state or element", "A type of font style", "A class with no styles", "A type of cursor"],
                correctAnswer: "A keyword used to select elements with a specific state or element",
                category: "CSS"
            },
            {
                question: "What does the CSS 'border-collapse' property control?",
                options: ["The width of an element's border", "The opacity of an element", "How table borders should be collapsed into a single border", "The font size"],
                correctAnswer: "How table borders should be collapsed into a single border",
                category: "CSS"
            },
            {
                question: "What is the purpose of the 'CSS transition' property?",
                options: ["To create animations", "To control the stacking order of elements", "To change text alignment", "To create animations when a CSS property changes"],
                correctAnswer: "To create animations when a CSS property changes",
                category: "CSS"
            },
            {
                question: "What does the 'CSS selector' '*' target in the DOM?",
                options: ["All elements in the DOM", "The first child element of an element", "All elements with a specific class name", "All elements with a specific tag name"],
                correctAnswer: "All elements in the DOM",
                category: "CSS"
            },
            {
                question: "What is the CSS 'position: fixed' property used for?",
                options: ["To position an element absolutely within its nearest positioned ancestor", "To make an element disappear", "To change text alignment", "To position an element relative to the viewport"],
                correctAnswer: "To position an element relative to the viewport",
                category: "CSS"
            }
        ]
    },
    React: {
        '1no': [
            {
                question: "What is React?",
                options: ["A JavaScript framework for building user interfaces", "A programming language", "A database management system", "A design pattern for mobile apps"],
                correctAnswer: "A JavaScript framework for building user interfaces",
                category: "React"
            },
            {
                question: "What is JSX in React?",
                options: ["A server-side rendering library", "A testing framework", "A data visualization tool", "A syntax extension for JavaScript that allows HTML-like code"],
                correctAnswer: "A syntax extension for JavaScript that allows HTML-like code",
                category: "React"
            },
            {
                question: "What is the virtual DOM in React used for?",
                options: ["To control hardware devices", "To optimize database queries", "To improve server performance", "To improve rendering performance in web applications"],
                correctAnswer: "To improve rendering performance in web applications",
                category: "React"
            },
            {
                question: "Which library is commonly used for client-side routing in React applications?",
                options: ["React Router", "jQuery", "Lodash", "Bootstrap"],
                correctAnswer: "React Router",
                category: "React"
            },
            {
                question: "What is Redux in the context of React?",
                options: ["A styling framework", "A data validation library", "A state management library", "A server-side rendering library"],
                correctAnswer: "A state management library",
                category: "React"
            },
            {
                question: "In React, what is a 'component'?",
                options: ["A server that handles API requests", "A function that returns JSX", "A database table", "A software testing tool"],
                correctAnswer: "A function that returns JSX",
                category: "React"
            },
            {
                question: "What is the purpose of 'props' in React components?",
                options: ["To manage database connections", "To define static data", "To pass data from parent to child components", "To handle API requests"],
                correctAnswer: "To pass data from parent to child components",
                category: "React"
            },
            {
                question: "What is the main advantage of using React for building user interfaces?",
                options: ["Automatic code generation", "Faster rendering performance", "Native mobile app development", "Built-in database management"],
                correctAnswer: "Faster rendering performance",
                category: "React"
            },
            {
                question: "What is 'state' in a React component?",
                options: ["A web server that serves static files", "A built-in React function", "A JavaScript object that holds data affecting a component's behavior", "A component's HTML structure"],
                correctAnswer: "A JavaScript object that holds data affecting a component's behavior",
                category: "React"
            },
            {
                question: "What is a 'React Hook' used for in functional components?",
                options: ["To create class components", "To interact with the DOM", "To add styling to components", "To add state and side effects to functional components"],
                correctAnswer: "To add state and side effects to functional components",
                category: "React"
            }
        ],
        'up-2no': [
            {
                question: "What is React?",
                options: ["A JavaScript framework for building user interfaces", "A programming language", "A database management system", "A design pattern for mobile apps"],
                correctAnswer: "A JavaScript framework for building user interfaces",
                category: "React"
            },
            {
                question: "What is JSX in React?",
                options: ["A server-side rendering library", "A testing framework", "A data visualization tool", "A syntax extension for JavaScript that allows HTML-like code"],
                correctAnswer: "A syntax extension for JavaScript that allows HTML-like code",
                category: "React"
            },
            {
                question: "What is the virtual DOM in React used for?",
                options: ["To control hardware devices", "To optimize database queries", "To improve server performance", "To improve rendering performance in web applications"],
                correctAnswer: "To improve rendering performance in web applications",
                category: "React"
            },
            {
                question: "Which library is commonly used for client-side routing in React applications?",
                options: ["React Router", "jQuery", "Lodash", "Bootstrap"],
                correctAnswer: "React Router",
                category: "React"
            },
            {
                question: "What is Redux in the context of React?",
                options: ["A styling framework", "A data validation library", "A state management library", "A server-side rendering library"],
                correctAnswer: "A state management library",
                category: "React"
            },
            {
                question: "In React, what is a 'component'?",
                options: ["A server that handles API requests", "A function that returns JSX", "A database table", "A software testing tool"],
                correctAnswer: "A function that returns JSX",
                category: "React"
            },
            {
                question: "What is the purpose of 'props' in React components?",
                options: ["To manage database connections", "To define static data", "To pass data from parent to child components", "To handle API requests"],
                correctAnswer: "To pass data from parent to child components",
                category: "React"
            },
            {
                question: "What is the main advantage of using React for building user interfaces?",
                options: ["Automatic code generation", "Faster rendering performance", "Native mobile app development", "Built-in database management"],
                correctAnswer: "Faster rendering performance",
                category: "React"
            },
            {
                question: "What is 'state' in a React component?",
                options: ["A web server that serves static files", "A built-in React function", "A JavaScript object that holds data affecting a component's behavior", "A component's HTML structure"],
                correctAnswer: "A JavaScript object that holds data affecting a component's behavior",
                category: "React"
            },
            {
                question: "What is a 'React Hook' used for in functional components?",
                options: ["To create class components", "To interact with the DOM", "To add styling to components", "To add state and side effects to functional components"],
                correctAnswer: "To add state and side effects to functional components",
                category: "React"
            }
        ],
        '3no': [
            {
                question: "What is the purpose of 'React Router' in a React application?",
                options: ["To create components", "To manage state", "To handle client-side routing", "To optimize database queries"],
                correctAnswer: "To handle client-side routing",
                category: "React"
            },
            {
                question: "What is the role of 'Redux' in a React-Redux application?",
                options: ["To manage component styles", "To define routes", "To provide a predictable state container", "To create new React components"],
                correctAnswer: "To provide a predictable state container",
                category: "React"
            },
            {
                question: "In React, what is a 'Higher-Order Component' (HOC) used for?",
                options: ["To optimize rendering performance", "To add styles to components", "To pass props to child components", "To create reusable logic that can be applied to multiple components"],
                correctAnswer: "To create reusable logic that can be applied to multiple components",
                category: "React"
            },
            {
                question: "What is the 'useState' hook used for in a React component?",
                options: ["To handle API requests", "To manage component state", "To create Redux actions", "To define routing in the application"],
                correctAnswer: "To manage component state",
                category: "React"
            },
            {
                question: "What is a 'React component prop' used for?",
                options: ["To style a component", "To define the component's structure", "To pass data from parent to child components", "To create Redux reducers"],
                correctAnswer: "To pass data from parent to child components",
                category: "React"
            },
            {
                question: "What is 'JSX' transformation in a React application?",
                options: ["Converting JavaScript code to XML", "Converting XML code to JavaScript", "Performing code analysis", "Defining component hierarchy"],
                correctAnswer: "Converting JSX code to JavaScript",
                category: "React"
            },
            {
                question: "In React, what is the 'useContext' hook used for?",
                options: ["To create functional components", "To manage routing", "To access context data without prop drilling", "To optimize database queries"],
                correctAnswer: "To access context data without prop drilling",
                category: "React"
            },
            {
                question: "What is the main advantage of using 'React Hooks' in functional components?",
                options: ["Enabling server-side rendering", "Enhancing component reusability", "Simplifying component state management", "Reducing the need for class components"],
                correctAnswer: "Reducing the need for class components",
                category: "React"
            },
            {
                question: "What is 'Redux Thunk' commonly used for in a React-Redux application?",
                options: ["Handling asynchronous actions", "Styling components", "Managing routing", "Optimizing API requests"],
                correctAnswer: "Handling asynchronous actions",
                category: "React"
            },
            {
                question: "In React, what is the 'componentDidMount' lifecycle method used for?",
                options: ["Styling components", "Handling component rendering", "Performing tasks after a component is added to the DOM", "Handling component state"],
                correctAnswer: "Performing tasks after a component is added to the DOM",
                category: "React"
            }
        ],
        '4no': [
            {
                question: "What is 'React.memo()' used for in React?",
                options: ["To define a class component", "To memoize functional components", "To create a new state variable", "To manage routing in a React application"],
                correctAnswer: "To memoize functional components",
                category: "React"
            },
            {
                question: "What is 'props.children' in a React component?",
                options: ["A reserved keyword in JSX", "The parent component's state", "A reference to the component's own children", "A component's default state"],
                correctAnswer: "A reference to the component's own children",
                category: "React"
            },
            {
                question: "What is the purpose of 'key' prop in React lists?",
                options: ["To define component styles", "To access the component's state", "To ensure proper component rendering and identification in lists", "To create routing logic"],
                correctAnswer: "To ensure proper component rendering and identification in lists",
                category: "React"
            },
            {
                question: "What is a 'React Portal' used for?",
                options: ["Managing component styles", "Rendering components outside their parent DOM hierarchy", "Creating Redux actions", "Handling API requests"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the purpose of 'shouldComponentUpdate' in a React class component?",
                options: ["Handling asynchronous actions", "Optimizing component rendering performance", "Creating stateful components", "Managing context data"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React.Fragment' used for?",
                options: ["Defining component styles", "Creating functional components", "Grouping multiple elements without adding extra nodes to the DOM", "Handling routing in a React application"],
                correctAnswer: "Grouping multiple elements without adding extra nodes to the DOM",
                category: "React"
            },
            {
                question: "What is 'context' in React used for?",
                options: ["To define Redux reducers", "To handle asynchronous actions", "To share data that can be considered 'global' to a component tree", "To manage routing"],
                correctAnswer: "To share data that can be considered 'global' to a component tree",
                category: "React"
            },
            {
                question: "What is the purpose of the 'useReducer' hook in React?",
                options: ["To create Redux actions", "To manage component styles", "To handle API requests", "To manage complex state logic in functional components"],
                correctAnswer: "To manage complex state logic in functional components",
                category: "React"
            },
            {
                question: "In React, what is 'prop types' used for?",
                options: ["Styling components", "Defining the type of props a component should receive", "Creating stateful components", "Handling routing logic"],
                correctAnswer: "Defining the type of props a component should receive",
                category: "React"
            },
            {
                question: "What is 'React Suspense' used for?",
                options: ["Defining Redux reducers", "Handling API requests", "Managing routing", "Handling asynchronous rendering of components and data fetching"],
                correctAnswer: "Handling asynchronous rendering of components and data fetching",
                category: "React"
            }
        ],
        '5no': [
            {
                question: "What is 'React Redux' used for?",
                options: ["Defining routing in a React application", "Creating native mobile apps", "State management for React applications", "Creating animations"],
                correctAnswer: "State management for React applications",
                category: "React"
            },
            {
                question: "What is the purpose of 'react-router-dom' in a React application?",
                options: ["Handling AJAX requests", "Creating Redux actions", "Defining component styles", "Managing client-side routing"],
                correctAnswer: "Managing client-side routing",
                category: "React"
            },
            {
                question: "What is 'React Router Switch' used for?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the 'useContext' hook used for in React?",
                options: ["Managing component styles", "To access context data without prop drilling", "To define Redux reducers", "Creating functional components"],
                correctAnswer: "To access context data without prop drilling",
                category: "React"
            },
            {
                question: "In React, what is a 'controlled component'?",
                options: ["A component that is difficult to control", "A component without state", "A component where form elements' values are controlled by React state", "A component with limited functionality"],
                correctAnswer: "A component where form elements' values are controlled by React state",
                category: "React"
            },
            {
                question: "What is 'JSX' transformation in a React application?",
                options: ["Converting JavaScript code to XML", "Converting XML code to JavaScript", "Performing code analysis", "Defining component hierarchy"],
                correctAnswer: "Converting JSX code to JavaScript",
                category: "React"
            },
            {
                question: "What is 'React Portals' used for?",
                options: ["Rendering components outside their parent DOM hierarchy", "Defining routing in a React application", "Styling components", "Creating Redux actions"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'key' attribute in React lists help with?",
                options: ["Defining component styles", "Ensuring proper component rendering and identification in lists", "Creating stateful components", "Optimizing database queries"],
                correctAnswer: "Ensuring proper component rendering and identification in lists",
                category: "React"
            },
            {
                question: "What is 'React PureComponent' used for?",
                options: ["Defining component styles", "Optimizing component rendering performance", "Handling API requests", "Creating Redux actions"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React Strict Mode' used for?",
                options: ["Enhancing component reusability", "Simplifying component state management", "Identifying and highlighting potential problems in an application", "Reducing the need for class components"],
                correctAnswer: "Identifying and highlighting potential problems in an application",
                category: "React"
            }
        ],
        'up-6no': [
            {
                question: "What is 'React Redux' used for?",
                options: ["Defining routing in a React application", "Creating native mobile apps", "State management for React applications", "Creating animations"],
                correctAnswer: "State management for React applications",
                category: "React"
            },
            {
                question: "What is the purpose of 'react-router-dom' in a React application?",
                options: ["Handling AJAX requests", "Creating Redux actions", "Defining component styles", "Managing client-side routing"],
                correctAnswer: "Managing client-side routing",
                category: "React"
            },
            {
                question: "What is 'React Router Switch' used for?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the 'useContext' hook used for in React?",
                options: ["Managing component styles", "To access context data without prop drilling", "To define Redux reducers", "Creating functional components"],
                correctAnswer: "To access context data without prop drilling",
                category: "React"
            },
            {
                question: "In React, what is a 'controlled component'?",
                options: ["A component that is difficult to control", "A component without state", "A component where form elements' values are controlled by React state", "A component with limited functionality"],
                correctAnswer: "A component where form elements' values are controlled by React state",
                category: "React"
            },
            {
                question: "What is 'JSX' transformation in a React application?",
                options: ["Converting JavaScript code to XML", "Converting XML code to JavaScript", "Performing code analysis", "Defining component hierarchy"],
                correctAnswer: "Converting JSX code to JavaScript",
                category: "React"
            },
            {
                question: "What is 'React Portals' used for?",
                options: ["Rendering components outside their parent DOM hierarchy", "Defining routing in a React application", "Styling components", "Creating Redux actions"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'key' attribute in React lists help with?",
                options: ["Defining component styles", "Ensuring proper component rendering and identification in lists", "Creating stateful components", "Optimizing database queries"],
                correctAnswer: "Ensuring proper component rendering and identification in lists",
                category: "React"
            },
            {
                question: "What is 'React PureComponent' used for?",
                options: ["Defining component styles", "Optimizing component rendering performance", "Handling API requests", "Creating Redux actions"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React Strict Mode' used for?",
                options: ["Enhancing component reusability", "Simplifying component state management", "Identifying and highlighting potential problems in an application", "Reducing the need for class components"],
                correctAnswer: "Identifying and highlighting potential problems in an application",
                category: "React"
            }
        ],
        '7no': [
            {
                question: "What is 'React Router Redirect' used for in a React application?",
                options: ["Creating animations", "Defining component styles", "Redirecting users to a different route", "Optimizing API requests"],
                correctAnswer: "Redirecting users to a different route",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' used for?",
                options: ["Managing client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is 'React Router Prompt' used for?",
                options: ["Creating Redux reducers", "Managing document head contents", "Displaying prompts before navigation in a React Router application", "Styling components"],
                correctAnswer: "Displaying prompts before navigation in a React Router application",
                category: "React"
            },
            {
                question: "What is 'React Context API' and how is it different from Redux for state management?",
                options: ["It's a library for creating animations in React", "It's a state management solution similar to Redux but lighter and built into React itself", "It's a server-side rendering tool", "It's a tool for optimizing API requests"],
                correctAnswer: "It's a state management solution similar to Redux but lighter and built into React itself",
                category: "React"
            },
            {
                question: "What is 'React Router useParams' used for?",
                options: ["Creating Redux actions", "Managing component styles", "Accessing route parameters in a React Router application", "Optimizing server-side rendering"],
                correctAnswer: "Accessing route parameters in a React Router application",
                category: "React"
            },
            {
                question: "What is the purpose of 'React.memo()' in a React application?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To manage routing", "To style components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "What is 'React Transition Group' used for?",
                options: ["Managing client-side routing", "Creating Redux reducers", "Managing animations during the entering and exiting of components", "Optimizing API requests"],
                correctAnswer: "Managing animations during the entering and exiting of components",
                category: "React"
            },
            {
                question: "What is the primary use case for 'React.memo()' in a React application?",
                options: ["To manage server-side rendering", "To create animations", "To optimize rendering performance by memoizing components", "To define component styles"],
                correctAnswer: "To optimize rendering performance by memoizing components",
                category: "React"
            },
            {
                question: "What is 'React Router Dom' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            }
        ],
        '8no': [
            {
                question: "What is 'React Router NavLink' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "What is 'React Hook Form' used for?",
                options: ["Optimizing component rendering performance", "Managing form state and validation in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing form state and validation in a React application",
                category: "React"
            },
            {
                question: "What is the main purpose of 'React Router useParams'?",
                options: ["Accessing route parameters in a React Router application", "Managing client-side routing", "Creating Redux reducers", "Optimizing server-side rendering"],
                correctAnswer: "Accessing route parameters in a React Router application",
                category: "React"
            },
            {
                question: "What is 'React Query Mutation' used for?",
                options: ["Optimizing component rendering performance", "Managing API mutations and updates in a React application", "Creating Redux actions", "Handling client-side routing"],
                correctAnswer: "Managing API mutations and updates in a React application",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' primarily used for?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is 'React Router Prompt' used for?",
                options: ["Creating Redux reducers", "Managing document head contents", "Displaying prompts before navigation in a React Router application", "Styling components"],
                correctAnswer: "Displaying prompts before navigation in a React Router application",
                category: "React"
            },
            {
                question: "What is 'React Transition Group' used for?",
                options: ["Managing client-side routing", "Creating Redux reducers", "Managing animations during the entering and exiting of components", "Optimizing API requests"],
                correctAnswer: "Managing animations during the entering and exiting of components",
                category: "React"
            },
            {
                question: "What is the primary purpose of 'React.memo()' in a React application?",
                options: ["To manage server-side rendering", "To create animations", "To optimize rendering performance by memoizing components", "To define component styles"],
                correctAnswer: "To optimize rendering performance by memoizing components",
                category: "React"
            },
            {
                question: "What is 'React Router Dom' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            }
        ],
        '--9no': [
            {
                question: "What is the purpose of 'React Portals' in a React application?",
                options: ["Creating animations", "Defining routing", "Rendering components outside their parent DOM hierarchy", "Optimizing API requests"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the primary use of 'React DevTools'?",
                options: ["Creating animations", "Optimizing API requests", "Helping developers inspect, debug, and profile React applications", "Handling server-side rendering"],
                correctAnswer: "Helping developers inspect, debug, and profile React applications",
                category: "React"
            },
            {
                question: "What is 'React Context' used for?",
                options: ["To manage server-side rendering", "To create animations", "To handle asynchronous actions", "To share data globally in a React component tree"],
                correctAnswer: "To share data globally in a React component tree",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' primarily used for?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is the difference between 'controlled' and 'uncontrolled' components in React forms?",
                options: ["There is no difference; the terms are interchangeable", "Controlled components are linked to component state, while uncontrolled components are not", "Controlled components use class-based components, while uncontrolled components use functional components", "Controlled components are used for client-side routing, while uncontrolled components are not"],
                correctAnswer: "Controlled components are linked to component state, while uncontrolled components are not",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch' in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            },
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React.memo()' used for in a React application?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To manage routing", "To style components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "What is 'React Router NavLink' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            }
        ],
        '10no': [
            {
                question: "What is 'React Portals' used for in a React application?",
                options: ["Creating animations", "Defining routing", "Rendering components outside their parent DOM hierarchy", "Optimizing API requests"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the primary use of 'React DevTools'?",
                options: ["Creating animations", "Optimizing API requests", "Helping developers inspect, debug, and profile React applications", "Handling server-side rendering"],
                correctAnswer: "Helping developers inspect, debug, and profile React applications",
                category: "React"
            },
            {
                question: "What is 'React Context' used for?",
                options: ["To manage server-side rendering", "To create animations", "To handle asynchronous actions", "To share data globally in a React component tree"],
                correctAnswer: "To share data globally in a React component tree",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' primarily used for?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is the difference between 'controlled' and 'uncontrolled' components in React forms?",
                options: ["There is no difference; the terms are interchangeable", "Controlled components are linked to component state, while uncontrolled components are not", "Controlled components use class-based components, while uncontrolled components use functional components", "Controlled components are used for client-side routing, while uncontrolled components are not"],
                correctAnswer: "Controlled components are linked to component state, while uncontrolled components are not",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch' in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            },
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React.memo()' used for in a React application?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To manage routing", "To style components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "What is 'React Router NavLink' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            }
        ],
        '11no': [
            {
                question: "What is the purpose of 'React Router useParams'?",
                options: ["Handling form submissions in React", "Accessing parameters from the URL in a React component", "Creating animations", "Optimizing API requests"],
                correctAnswer: "Accessing parameters from the URL in a React component",
                category: "React"
            },
            {
                question: "How does 'React.memo()' optimize functional components in React?",
                options: ["By creating animations", "By preventing unnecessary renders of the component", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By preventing unnecessary renders of the component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Context' in a React application?",
                options: ["Handling client-side routing", "Managing state at the global level without prop drilling", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Managing state at the global level without prop drilling",
                category: "React"
            },
            {
                question: "How does 'React Router useNavigate' differ from 'useHistory'?",
                options: ["Handling client-side routing", "Creating animations", "Navigating without relying on the component hierarchy", "Styling components"],
                correctAnswer: "Navigating without relying on the component hierarchy",
                category: "React"
            },
            {
                question: "What is the purpose of 'React.PureComponent'?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "How does 'React Router useLocation' provide information about the current URL?",
                options: ["By creating animations", "By accessing the browser's location object", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By accessing the browser's location object",
                category: "React"
            },
            {
                question: "What does the 'useEffect' hook do in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Prompt'?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            },
            {
                question: "In React, what is the significance of the 'ref' attribute?",
                options: ["Optimizing component rendering performance", "Creating animations", "Creating a reference to a React element or component", "Handling server-side rendering"],
                correctAnswer: "Creating a reference to a React element or component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Redux Toolkit'?",
                options: ["By creating animations", "By providing a set of tools and conventions for common Redux patterns", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By providing a set of tools and conventions for common Redux patterns",
                category: "React"
            }
        ],
        '12no': [
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch'?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "How does 'React.lazy()' contribute to code splitting in React applications?",
                options: ["By creating animations", "By loading components lazily only when they are actually needed", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By loading components lazily only when they are actually needed",
                category: "React"
            },
            {
                question: "What is the primary purpose of 'React Hooks'?",
                options: ["To create class components", "To manage asynchronous actions in Redux", "To enable the use of state and other React features in functional components", "To handle client-side routing"],
                correctAnswer: "To enable the use of state and other React features in functional components",
                category: "React"
            },
            {
                question: "How does 'React Router Switch' work in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Portals'?",
                options: ["Managing API requests", "Rendering components outside their parent DOM hierarchy", "Creating animations", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'useEffect' hook do in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Prompt'?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            },
            {
                question: "In React, what is the significance of the 'ref' attribute?",
                options: ["Optimizing component rendering performance", "Creating animations", "Creating a reference to a React element or component", "Handling server-side rendering"],
                correctAnswer: "Creating a reference to a React element or component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Redux Toolkit'?",
                options: ["By creating animations", "By providing a set of tools and conventions for common Redux patterns", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By providing a set of tools and conventions for common Redux patterns",
                category: "React"
            }
        ],
        '13no': [
            {
                question: "What is the purpose of 'React Router Switch'?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "How does 'React.memo()' optimize functional components in React?",
                options: ["By creating animations", "By preventing unnecessary renders of the component", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By preventing unnecessary renders of the component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Context' in a React application?",
                options: ["Handling client-side routing", "Managing state at the global level without prop drilling", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Managing state at the global level without prop drilling",
                category: "React"
            },
            {
                question: "How does 'React Router Redirect' work in a React application?",
                options: ["Redirecting to a new URL", "Creating animation effects in React components", "Handling asynchronous actions in Redux", "Optimizing API requests"],
                correctAnswer: "Redirecting to a new URL",
                category: "React"
            },
            {
                question: "What is the purpose of 'React.PureComponent'?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "How does 'React Router withRouter' enhance a React component?",
                options: ["Creating animations", "Rendering components outside their parent DOM hierarchy", "Providing access to the history object", "Optimizing component rendering performance"],
                correctAnswer: "Providing access to the history object",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Fragment' in React?",
                options: ["Managing API requests", "Rendering components outside their parent DOM hierarchy", "Creating animations", "Grouping multiple elements without adding extra nodes to the DOM"],
                correctAnswer: "Grouping multiple elements without adding extra nodes to the DOM",
                category: "React"
            },
            {
                question: "How does 'React Router Link' differ from 'React Router NavLink'?",
                options: ["Handling client-side routing", "Creating animations", "Rendering components lazily", "Styling components"],
                correctAnswer: "Styling components",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router withRouter' enhance a React component?",
                options: ["Creating animations", "Rendering components outside their parent DOM hierarchy", "Providing access to the history object", "Optimizing component rendering performance"],
                correctAnswer: "Providing access to the history object",
                category: "React"
            },
            {
                question: "How does 'React Router Prompt' work in a React application?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            }
        ],
        '14no': [
            {
                question: "What is 'React Portals' used for in a React application?",
                options: ["Creating animations", "Defining routing", "Rendering components outside their parent DOM hierarchy", "Optimizing API requests"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the primary use of 'React DevTools'?",
                options: ["Creating animations", "Optimizing API requests", "Helping developers inspect, debug, and profile React applications", "Handling server-side rendering"],
                correctAnswer: "Helping developers inspect, debug, and profile React applications",
                category: "React"
            },
            {
                question: "What is 'React Context' used for?",
                options: ["To manage server-side rendering", "To create animations", "To handle asynchronous actions", "To share data globally in a React component tree"],
                correctAnswer: "To share data globally in a React component tree",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' primarily used for?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is the difference between 'controlled' and 'uncontrolled' components in React forms?",
                options: ["There is no difference; the terms are interchangeable", "Controlled components are linked to component state, while uncontrolled components are not", "Controlled components use class-based components, while uncontrolled components use functional components", "Controlled components are used for client-side routing, while uncontrolled components are not"],
                correctAnswer: "Controlled components are linked to component state, while uncontrolled components are not",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch' in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            },
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "What is 'React.memo()' used for in a React application?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To manage routing", "To style components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "What is 'React Router NavLink' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            }
        ],
        '15no': [
            {
                question: "What is the primary use of 'React DevTools'?",
                options: ["Creating animations", "Optimizing API requests", "Helping developers inspect, debug, and profile React applications", "Handling server-side rendering"],
                correctAnswer: "Helping developers inspect, debug, and profile React applications",
                category: "React"
            },
            {
                question: "What is 'React Context' used for?",
                options: ["To manage server-side rendering", "To create animations", "To handle asynchronous actions", "To share data globally in a React component tree"],
                correctAnswer: "To share data globally in a React component tree",
                category: "React"
            },
            {
                question: "What is 'React Testing Library' primarily used for?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "What is the difference between 'controlled' and 'uncontrolled' components in React forms?",
                options: ["There is no difference; the terms are interchangeable", "Controlled components are linked to component state, while uncontrolled components are not", "Controlled components use class-based components, while uncontrolled components use functional components", "Controlled components are used for client-side routing, while uncontrolled components are not"],
                correctAnswer: "Controlled components are linked to component state, while uncontrolled components are not",
                category: "React"
            },
            {
                question: "What is 'React Portals' used for in a React application?",
                options: ["Creating animations", "Defining routing", "Rendering components outside their parent DOM hierarchy", "Optimizing API requests"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch' in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is 'React Query' used for?",
                options: ["Optimizing component rendering performance", "Managing API requests and caching in a React application", "Creating animations", "Handling client-side routing"],
                correctAnswer: "Managing API requests and caching in a React application",
                category: "React"
            },
            {
                question: "What is the virtual DOM in React used for?",
                options: ["To control hardware devices", "To optimize database queries", "To improve server performance", "To improve rendering performance in web applications"],
                correctAnswer: "To improve rendering performance in web applications",
                category: "React"
            },
            {
                question: "How does 'React Router Switch' work in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is 'React Router NavLink' used for?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            }
        ],
        '16no': [
            {
                question: "What is the purpose of 'React Router NavLink'?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "How does 'React.lazy()' contribute to code splitting in React applications?",
                options: ["By creating animations", "By loading components lazily only when they are actually needed", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By loading components lazily only when they are actually needed",
                category: "React"
            },
            {
                question: "What is the primary purpose of 'React Hooks'?",
                options: ["To create class components", "To manage asynchronous actions in Redux", "To enable the use of state and other React features in functional components", "To handle client-side routing"],
                correctAnswer: "To enable the use of state and other React features in functional components",
                category: "React"
            },
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "How does 'React Router Switch' work in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Portals'?",
                options: ["Managing API requests", "Rendering components outside their parent DOM hierarchy", "Creating animations", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'useEffect' hook do in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Prompt'?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            },
            {
                question: "In React, what is the significance of the 'ref' attribute?",
                options: ["Optimizing component rendering performance", "Creating animations", "Creating a reference to a React element or component", "Handling server-side rendering"],
                correctAnswer: "Creating a reference to a React element or component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Redux Toolkit'?",
                options: ["By creating animations", "By providing a set of tools and conventions for common Redux patterns", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By providing a set of tools and conventions for common Redux patterns",
                category: "React"
            }
        ],
        '17no': [
            {
                question: "What does 'React.StrictMode' do in a React application?",
                options: ["Optimizes component rendering performance", "Enforces strict linting rules", "Detects common mistakes and potential issues early in development", "Handles server-side rendering"],
                correctAnswer: "Detects common mistakes and potential issues early in development",
                category: "React"
            },
            {
                question: "What is the purpose of the 'key' prop in React lists?",
                options: ["Styling components", "Optimizing API requests", "Ensuring unique identification for each list item", "Handling client-side routing"],
                correctAnswer: "Ensuring unique identification for each list item",
                category: "React"
            },
            {
                question: "How does 'React.memo()' optimize functional components in React?",
                options: ["By creating animations", "By memoizing the component to prevent unnecessary renders", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By memoizing the component to prevent unnecessary renders",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router NavLink'?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "How does 'React.lazy()' contribute to code splitting in React applications?",
                options: ["By creating animations", "By loading components lazily only when they are actually needed", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By loading components lazily only when they are actually needed",
                category: "React"
            },
            {
                question: "What is the primary purpose of 'React Hooks'?",
                options: ["To create class components", "To manage asynchronous actions in Redux", "To enable the use of state and other React features in functional components", "To handle client-side routing"],
                correctAnswer: "To enable the use of state and other React features in functional components",
                category: "React"
            },
            {
                question: "What is 'React Fiber' in React used for?",
                options: ["Optimizing component rendering performance", "Creating Redux reducers", "Handling client-side routing", "Styling components"],
                correctAnswer: "Optimizing component rendering performance",
                category: "React"
            },
            {
                question: "How does 'React Router Switch' work in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Portals'?",
                options: ["Managing API requests", "Rendering components outside their parent DOM hierarchy", "Creating animations", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside their parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'useEffect' hook do in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            }
        ],
        '18no': [
            {
                question: "What is the purpose of 'React Fragments'?",
                options: ["To create animations", "To group multiple elements without adding extra nodes to the DOM", "To optimize API requests", "To handle asynchronous actions"],
                correctAnswer: "To group multiple elements without adding extra nodes to the DOM",
                category: "React"
            },
            {
                question: "In React, what is the role of 'JSX'?",
                options: ["To define styles for components", "To perform server-side rendering", "To specify the layout of a React component", "To manage state in functional components"],
                correctAnswer: "To specify the layout of a React component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Hooks'?",
                options: ["To create class components", "To manage asynchronous actions in Redux", "To enable the use of state and other React features in functional components", "To handle client-side routing"],
                correctAnswer: "To enable the use of state and other React features in functional components",
                category: "React"
            },
            {
                question: "What is 'React Redux' used for in a React application?",
                options: ["Handling client-side routing", "Managing API requests", "State management using the Redux library in React", "Creating animations"],
                correctAnswer: "State management using the Redux library in React",
                category: "React"
            },
            {
                question: "How do you update the state in a React class component?",
                options: ["Using the 'setState' method", "Directly modifying the state object", "By creating a new component instance", "Using the 'updateState' method"],
                correctAnswer: "Using the 'setState' method",
                category: "React"
            },
            {
                question: "What is the purpose of the 'useEffect' hook in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            },
            {
                question: "What is 'React Router' used for?",
                options: ["Creating animations", "Handling client-side routing in a React application", "Managing API requests", "State management in React components"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "What is the purpose of 'Redux Thunk' middleware in a React-Redux application?",
                options: ["Handling server-side rendering", "Optimizing component rendering performance", "Managing asynchronous actions in Redux", "Creating animations"],
                correctAnswer: "Managing asynchronous actions in Redux",
                category: "React"
            },
            {
                question: "What is the role of 'React.memo()' in optimizing React applications?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To handle client-side routing", "To manage state in class components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "How can you conditionally render content in React?",
                options: ["By using the 'if' statement within JSX", "By directly manipulating the DOM", "By using the 'renderConditionally' prop", "By using conditional rendering techniques like ternary operators or logical '&&'"],
                correctAnswer: "By using conditional rendering techniques like ternary operators or logical '&&'",
                category: "React"
            }
        ],
        '19no': [
            {
                question: "What is the purpose of 'React Router NavLink'?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "How does 'React.lazy()' contribute to code splitting in React applications?",
                options: ["By creating animations", "By loading components lazily only when they are actually needed", "By handling server-side rendering", "By optimizing API requests"],
                correctAnswer: "By loading components lazily only when they are actually needed",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Prompt'?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            },
            {
                question: "In React, what is the significance of the 'ref' attribute?",
                options: ["Optimizing component rendering performance", "Creating animations", "Creating a reference to a React element or component", "Handling server-side rendering"],
                correctAnswer: "Creating a reference to a React element or component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Redux Toolkit'?",
                options: ["By creating animations", "By providing a set of tools and conventions for common Redux patterns", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By providing a set of tools and conventions for common Redux patterns",
                category: "React"
            },
            {
                question: "How does 'React Router Redirect' work in a React application?",
                options: ["Redirecting to the home page", "Creating animation effects in React components", "Handling API requests", "Redirecting to a specified route"],
                correctAnswer: "Redirecting to a specified route",
                category: "React"
            },
            {
                question: "What is the purpose of 'React.memo()' in a React application?",
                options: ["Creating animations", "Memoizing functional components for performance optimization", "Handling client-side routing", "Styling components"],
                correctAnswer: "Memoizing functional components for performance optimization",
                category: "React"
            },
            {
                question: "How does 'React Router Switch' work in a React application?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            },
            {
                question: "What is the role of 'React Portal'?",
                options: ["Creating animations", "Rendering components outside the parent DOM hierarchy", "Handling API requests", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside the parent DOM hierarchy",
                category: "React"
            },
            {
                question: "In React, what is the purpose of 'PropTypes'?",
                options: ["To define styles for components", "To perform server-side rendering", "To specify the expected data types of props", "To manage state in functional components"],
                correctAnswer: "To specify the expected data types of props",
                category: "React"
            }
        ],
        '20no': [
            {
                question: "What is the purpose of 'React Router Prompt'?",
                options: ["Creating animations", "Prompting the user before navigating away from a page", "Optimizing API requests", "Handling client-side routing"],
                correctAnswer: "Prompting the user before navigating away from a page",
                category: "React"
            },
            {
                question: "In React, what is the significance of the 'ref' attribute?",
                options: ["Optimizing component rendering performance", "Creating animations", "Creating a reference to a React element or component", "Handling server-side rendering"],
                correctAnswer: "Creating a reference to a React element or component",
                category: "React"
            },
            {
                question: "How does 'React Redux Toolkit' simplify Redux usage in a React application?",
                options: ["By creating animations", "By providing a set of tools and conventions for common Redux patterns", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By providing a set of tools and conventions for common Redux patterns",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Redirect'?",
                options: ["Redirecting to the home page", "Creating animation effects in React components", "Handling API requests", "Redirecting to a specified route"],
                correctAnswer: "Redirecting to a specified route",
                category: "React"
            },
            {
                question: "How does 'React.memo()' optimize functional components in React?",
                options: ["By creating animations", "By memoizing the component to prevent unnecessary renders", "By handling client-side routing", "By optimizing API requests"],
                correctAnswer: "By memoizing the component to prevent unnecessary renders",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router NavLink'?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            },
            {
                question: "What is the role of 'React Portal'?",
                options: ["Creating animations", "Rendering components outside the parent DOM hierarchy", "Handling API requests", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside the parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Testing Library'?",
                options: ["Handling client-side routing", "Optimizing component rendering performance", "Testing React components by focusing on user interactions", "Creating Redux actions"],
                correctAnswer: "Testing React components by focusing on user interactions",
                category: "React"
            },
            {
                question: "How can you conditionally render content in React?",
                options: ["Using the 'if' statement within JSX", "Directly manipulating the DOM", "Using the 'renderConditionally' prop", "Using conditional rendering techniques like ternary operators or logical '&&'"],
                correctAnswer: "Using conditional rendering techniques like ternary operators or logical '&&'",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Router Switch'?",
                options: ["Defining a switch statement in a React component", "Creating animation effects in React components", "Rendering the first child Route that matches", "Handling asynchronous actions in Redux"],
                correctAnswer: "Rendering the first child Route that matches",
                category: "React"
            }
        ],
        '21no': [
            {
                question: "What is the purpose of 'React Lazy' and 'React Suspense'?",
                options: ["Handling server-side rendering", "Optimizing component rendering performance", "Code splitting for better loading performance", "Creating animations"],
                correctAnswer: "Code splitting for better loading performance",
                category: "React"
            },
            {
                question: "What is the significance of the 'key' prop in React lists?",
                options: ["Styling components", "Optimizing API requests", "Ensuring unique identification for each list item", "Handling client-side routing"],
                correctAnswer: "Ensuring unique identification for each list item",
                category: "React"
            },
            {
                question: "In React, what is the purpose of 'PropTypes'?",
                options: ["To define styles for components", "To perform server-side rendering", "To specify the expected data types of props", "To manage state in functional components"],
                correctAnswer: "To specify the expected data types of props",
                category: "React"
            },
            {
                question: "What is the role of 'React.memo()' in optimizing React applications?",
                options: ["To create animations", "To memoize functional components for performance optimization", "To handle client-side routing", "To manage state in class components"],
                correctAnswer: "To memoize functional components for performance optimization",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Hooks'?",
                options: ["To create class components", "To manage asynchronous actions in Redux", "To enable the use of state and other React features in functional components", "To handle client-side routing"],
                correctAnswer: "To enable the use of state and other React features in functional components",
                category: "React"
            },
            {
                question: "How does 'React Router' handle 404 errors in a React application?",
                options: ["Redirecting to the home page", "Rendering a custom 404 component", "Throwing an error", "Reloading the current page"],
                correctAnswer: "Rendering a custom 404 component",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Portal'?",
                options: ["Creating animations", "Rendering components outside the parent DOM hierarchy", "Handling API requests", "Optimizing component rendering performance"],
                correctAnswer: "Rendering components outside the parent DOM hierarchy",
                category: "React"
            },
            {
                question: "What does the 'useEffect' hook do in React?",
                options: ["To define styles for components", "To manage asynchronous actions", "To perform side effects in functional components", "To handle client-side routing"],
                correctAnswer: "To perform side effects in functional components",
                category: "React"
            },
            {
                question: "What is the purpose of 'React Context'?",
                options: ["To manage server-side rendering", "To create animations", "To share global data in a React component tree", "To handle asynchronous actions"],
                correctAnswer: "To share global data in a React component tree",
                category: "React"
            },
            {
                question: "What is the role of 'React Router NavLink'?",
                options: ["Styling components", "Handling client-side routing in a React application", "Creating Redux actions", "Optimizing API requests"],
                correctAnswer: "Handling client-side routing in a React application",
                category: "React"
            }
        ],
    },
    NodeJS: {
        '1no': [
            {
                question: "What is Node.js?",
                options: ["A JavaScript runtime environment that executes code outside of a browser", "A web browser", "A front-end JavaScript framework", "A relational database management system"],
                correctAnswer: "A JavaScript runtime environment that executes code outside of a browser",
                category: "Node.js"
            },
            {
                question: "Which package manager is commonly used in Node.js for installing and managing dependencies?",
                options: ["npm (Node Package Manager)", "yarn", "pip", "composer"],
                correctAnswer: "npm (Node Package Manager)",
                category: "Node.js"
            },
            {
                question: "What is the primary use of 'require' in Node.js?",
                options: ["To define a new variable", "To include external modules or libraries", "To create a function", "To perform mathematical calculations"],
                correctAnswer: "To include external modules or libraries",
                category: "Node.js"
            },
            {
                question: "What is the Node.js event loop?",
                options: ["A loop that waits for user input", "A loop that iterates through arrays", "A mechanism for handling asynchronous operations", "A loop that calculates prime numbers"],
                correctAnswer: "A mechanism for handling asynchronous operations",
                category: "Node.js"
            },
            {
                question: "Which core module in Node.js is used for handling file operations?",
                options: ["http", "fs (File System)", "os", "events"],
                correctAnswer: "fs (File System)",
                category: "Node.js"
            },
            {
                question: "What is 'npm' in the context of Node.js?",
                options: ["A package manager for Python", "A built-in JavaScript function", "A JavaScript runtime environment", "A package manager for Node.js modules"],
                correctAnswer: "A package manager for Node.js modules",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'Buffer' class in Node.js?",
                options: ["To handle HTTP requests", "To manipulate and store binary data", "To create event listeners", "To define CSS styles"],
                correctAnswer: "To manipulate and store binary data",
                category: "Node.js"
            },
            {
                question: "What is the role of the 'exports' object in Node.js modules?",
                options: ["To import modules from other files", "To define global variables", "To make functions accessible to other modules", "To execute a function"],
                correctAnswer: "To make functions accessible to other modules",
                category: "Node.js"
            },
            {
                question: "In Node.js, which method is used for making HTTP requests?",
                options: ["request()", "fetch()", "sendRequest()", "httpRequest()"],
                correctAnswer: "request()",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'npm init' command in Node.js?",
                options: ["To uninstall a package", "To update Node.js to the latest version", "To initialize a new Node.js project and create a 'package.json' file", "To start a development server"],
                correctAnswer: "To initialize a new Node.js project and create a 'package.json' file",
                category: "Node.js"
            }
        ],
        '2no': [
            {
                question: "What is 'Express' in the context of Node.js?",
                options: ["A built-in Node.js module", "A front-end framework", "A web application framework for Node.js", "A relational database"],
                correctAnswer: "A web application framework for Node.js",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'npm install' command in Node.js?",
                options: ["To update Node.js to the latest version", "To uninstall a package", "To install Node.js itself", "To install packages and dependencies for a Node.js project"],
                correctAnswer: "To install packages and dependencies for a Node.js project",
                category: "Node.js"
            },
            {
                question: "What is 'middleware' in the context of Express.js?",
                options: ["A software development methodology", "A web server technology", "A term for software bugs", "Functions that process incoming HTTP requests"],
                correctAnswer: "Functions that process incoming HTTP requests",
                category: "Node.js"
            },
            {
                question: "What is the primary purpose of the 'EventEmitter' module in Node.js?",
                options: ["To manage HTTP requests", "To manipulate binary data", "To handle events and event-driven programming", "To create web servers"],
                correctAnswer: "To handle events and event-driven programming",
                category: "Node.js"
            },
            {
                question: "What is 'npm audit' used for in Node.js?",
                options: ["To run unit tests for a Node.js project", "To analyze and report security vulnerabilities in project dependencies", "To create a new Node.js project", "To generate API documentation"],
                correctAnswer: "To analyze and report security vulnerabilities in project dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'CommonJS' in the context of Node.js modules?",
                options: ["A JavaScript framework", "A module system for organizing and sharing code in Node.js", "A front-end library", "A web server technology"],
                correctAnswer: "A module system for organizing and sharing code in Node.js",
                category: "Node.js"
            },
            {
                question: "What is the 'package.json' file used for in a Node.js project?",
                options: ["To store binary data", "To define CSS styles", "To specify project metadata and dependencies", "To manage HTTP requests"],
                correctAnswer: "To specify project metadata and dependencies",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'require' function in Node.js?",
                options: ["To define a new variable", "To create functions", "To include external modules or libraries", "To uninstall packages"],
                correctAnswer: "To include external modules or libraries",
                category: "Node.js"
            },
            {
                question: "What is 'NPM' in the context of Node.js?",
                options: ["Node.js Package Manager", "Node Process Manager", "Node Programming Module", "Node Project Manager"],
                correctAnswer: "Node.js Package Manager",
                category: "Node.js"
            },
            {
                question: "What does 'callback hell' refer to in Node.js?",
                options: ["A playful term for happy coding moments", "A design pattern for front-end development", "A situation where deeply nested callback functions make code hard to read and maintain", "A popular Node.js library"],
                correctAnswer: "A situation where deeply nested callback functions make code hard to read and maintain",
                category: "Node.js"
            }
        ],
        '3no': [
            {
                question: "What is 'npm' (Node Package Manager) used for in Node.js?",
                options: ["To format strings", "To create web servers", "To install and manage packages and dependencies", "To define CSS styles"],
                correctAnswer: "To install and manage packages and dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'Node.js' built on top of?",
                options: ["Java", "Python", "C++", "JavaScript"],
                correctAnswer: "JavaScript",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'fs' module in Node.js?",
                options: ["To handle HTTP requests", "To define a function", "To manipulate and interact with the file system", "To create animations"],
                correctAnswer: "To manipulate and interact with the file system",
                category: "Node.js"
            },
            {
                question: "What is the role of 'event emitters' in Node.js?",
                options: ["To manage HTTP requests", "To add event listeners", "To create web servers", "To handle and trigger events"],
                correctAnswer: "To handle and trigger events",
                category: "Node.js"
            },
            {
                question: "What is the 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To manipulate binary data", "To process incoming HTTP requests and responses", "To calculate prime numbers"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            },
            {
                question: "What is 'npm start' used for in Node.js projects?",
                options: ["To format strings", "To uninstall a package", "To start the application specified in the 'scripts' section of 'package.json'", "To create animations"],
                correctAnswer: "To start the application specified in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What does the 'event loop' in Node.js do?",
                options: ["Waits for user input", "Iterates through arrays", "Handles asynchronous operations", "Calculates mathematical operations"],
                correctAnswer: "Handles asynchronous operations",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'require' function in Node.js?",
                options: ["To define a new variable", "To include external modules or libraries", "To create functions", "To stop execution of a function"],
                correctAnswer: "To include external modules or libraries",
                category: "Node.js"
            },
            {
                question: "What is 'Express' in Node.js often used for?",
                options: ["To create animations", "To define back-end routes and handle HTTP requests", "To perform mathematical calculations", "To manage databases"],
                correctAnswer: "To define back-end routes and handle HTTP requests",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'npm install' command in Node.js?",
                options: ["To uninstall a package", "To update Node.js to the latest version", "To initialize a new Node.js project", "To install packages and dependencies for a Node.js project"],
                correctAnswer: "To install packages and dependencies for a Node.js project",
                category: "Node.js"
            }
        ],
        '--4no': [
            {
                question: "What is 'npm' (Node Package Manager) used for in Node.js?",
                options: ["To format strings", "To create web servers", "To install and manage packages and dependencies", "To define CSS styles"],
                correctAnswer: "To install and manage packages and dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'Node.js' built on top of?",
                options: ["Java", "Python", "C++", "JavaScript"],
                correctAnswer: "JavaScript",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'fs' module in Node.js?",
                options: ["To handle HTTP requests", "To define a function", "To manipulate and interact with the file system", "To create animations"],
                correctAnswer: "To manipulate and interact with the file system",
                category: "Node.js"
            },
            {
                question: "What is the role of 'event emitters' in Node.js?",
                options: ["To manage HTTP requests", "To add event listeners", "To create web servers", "To handle and trigger events"],
                correctAnswer: "To handle and trigger events",
                category: "Node.js"
            },
            {
                question: "What is the 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To manipulate binary data", "To process incoming HTTP requests and responses", "To calculate prime numbers"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            },
            {
                question: "What is 'npm start' used for in Node.js projects?",
                options: ["To format strings", "To uninstall a package", "To start the application specified in the 'scripts' section of 'package.json'", "To create animations"],
                correctAnswer: "To start the application specified in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What does the 'event loop' in Node.js do?",
                options: ["Waits for user input", "Iterates through arrays", "Handles asynchronous operations", "Calculates mathematical operations"],
                correctAnswer: "Handles asynchronous operations",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'require' function in Node.js?",
                options: ["To define a new variable", "To include external modules or libraries", "To create functions", "To stop execution of a function"],
                correctAnswer: "To include external modules or libraries",
                category: "Node.js"
            },
            {
                question: "What is 'Express' in Node.js often used for?",
                options: ["To create animations", "To define back-end routes and handle HTTP requests", "To perform mathematical calculations", "To manage databases"],
                correctAnswer: "To define back-end routes and handle HTTP requests",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'npm install' command in Node.js?",
                options: ["To uninstall a package", "To update Node.js to the latest version", "To initialize a new Node.js project", "To install packages and dependencies for a Node.js project"],
                correctAnswer: "To install packages and dependencies for a Node.js project",
                category: "Node.js"
            }
        ],
        '5no': [
            {
                question: "What is 'npm run start' typically used for in a Node.js project?",
                options: ["To start a development server", "To uninstall a package", "To run unit tests", "To define a new variable"],
                correctAnswer: "To start a development server",
                category: "Node.js"
            },
            {
                question: "What is 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To process incoming HTTP requests and responses", "To manipulate binary data", "To manage databases"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'cluster' module in Node.js?",
                options: ["To create animations", "To connect to a database", "To manage worker processes in a multi-core system", "To manipulate and store binary data"],
                correctAnswer: "To manage worker processes in a multi-core system",
                category: "Node.js"
            },
            {
                question: "What does 'Node Package Manager (npm)' help you manage in a Node.js project?",
                options: ["Project hardware requirements", "Development servers", "Project dependencies and packages", "Front-end design styles"],
                correctAnswer: "Project dependencies and packages",
                category: "Node.js"
            },
            {
                question: "What is 'Node.js REPL' used for?",
                options: ["To create web servers", "To run JavaScript code interactively", "To manipulate the file system", "To manage HTTP requests"],
                correctAnswer: "To run JavaScript code interactively",
                category: "Node.js"
            },
            {
                question: "What is the role of 'event emitters' in Node.js?",
                options: ["To add event listeners", "To create animations", "To calculate mathematical operations", "To handle and trigger events"],
                correctAnswer: "To handle and trigger events",
                category: "Node.js"
            },
            {
                question: "What is the 'package.json' file used for in a Node.js project?",
                options: ["To store binary data", "To define CSS styles", "To specify project metadata and dependencies", "To run unit tests"],
                correctAnswer: "To specify project metadata and dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm audit' used for in Node.js?",
                options: ["To generate API documentation", "To uninstall a package", "To analyze and report security vulnerabilities in project dependencies", "To format strings"],
                correctAnswer: "To analyze and report security vulnerabilities in project dependencies",
                category: "Node.js"
            },
            {
                question: "What does the 'event loop' in Node.js handle?",
                options: ["HTTP requests", "Asynchronous operations", "Mathematical calculations", "File operations"],
                correctAnswer: "Asynchronous operations",
                category: "Node.js"
            },
            {
                question: "What is the primary purpose of the 'fs' (File System) module in Node.js?",
                options: ["To create web servers", "To manipulate and interact with the file system", "To manage databases", "To handle HTTP requests"],
                correctAnswer: "To manipulate and interact with the file system",
                category: "Node.js"
            }
        ],
        '6no': [
            {
                question: "What is the primary use of 'npm init' in a Node.js project?",
                options: ["To update Node.js to the latest version", "To create a new Node.js project and generate a 'package.json' file", "To uninstall a package", "To start the application"],
                correctAnswer: "To create a new Node.js project and generate a 'package.json' file",
                category: "Node.js"
            },
            {
                question: "What does 'npm install' do in a Node.js project?",
                options: ["Removes all project dependencies", "Installs project dependencies from the 'package.json' file", "Starts the Node.js application", "Uninstalls Node.js"],
                correctAnswer: "Installs project dependencies from the 'package.json' file",
                category: "Node.js"
            },
            {
                question: "What is 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To manipulate binary data", "To process incoming HTTP requests and responses", "To manage databases"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            },
            {
                question: "What is 'npm run start' typically used for in a Node.js project?",
                options: ["To start a development server", "To uninstall a package", "To run unit tests", "To define a new variable"],
                correctAnswer: "To start a development server",
                category: "Node.js"
            },
            {
                question: "What is 'callback' in the context of Node.js?",
                options: ["A function that is executed immediately", "A function that is called after an asynchronous operation completes", "A type of error in Node.js", "A way to handle user input"],
                correctAnswer: "A function that is called after an asynchronous operation completes",
                category: "Node.js"
            },
            {
                question: "What does 'Node Package Manager (npm)' help you manage in a Node.js project?",
                options: ["Project hardware requirements", "Development servers", "Project dependencies and packages", "Front-end design styles"],
                correctAnswer: "Project dependencies and packages",
                category: "Node.js"
            },
            {
                question: "What is 'global' in Node.js?",
                options: ["A built-in Node.js module", "A variable that can be accessed from any module", "A popular Node.js framework", "A type of error in Node.js"],
                correctAnswer: "A variable that can be accessed from any module",
                category: "Node.js"
            },
            {
                question: "What is 'Node.js REPL' used for?",
                options: ["To create web servers", "To run JavaScript code interactively", "To manipulate the file system", "To manage HTTP requests"],
                correctAnswer: "To run JavaScript code interactively",
                category: "Node.js"
            },
            {
                question: "What is 'cluster' in Node.js used for?",
                options: ["To create animations", "To connect to a database", "To manage worker processes in a multi-core system", "To manipulate and store binary data"],
                correctAnswer: "To manage worker processes in a multi-core system",
                category: "Node.js"
            },
            {
                question: "What is 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To process incoming HTTP requests and responses", "To manipulate binary data", "To manage databases"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            }
        ],
        '--7no': [
            {
                question: "What is 'npm run start' typically used for in a Node.js project?",
                options: ["To start a development server", "To uninstall a package", "To run unit tests", "To define a new variable"],
                correctAnswer: "To start a development server",
                category: "Node.js"
            },
            {
                question: "What is 'middleware' in Express.js used for?",
                options: ["To define front-end styles", "To manipulate binary data", "To process incoming HTTP requests and responses", "To manage databases"],
                correctAnswer: "To process incoming HTTP requests and responses",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'cluster' module in Node.js?",
                options: ["To create animations", "To connect to a database", "To manage worker processes in a multi-core system", "To manipulate and store binary data"],
                correctAnswer: "To manage worker processes in a multi-core system",
                category: "Node.js"
            },
            {
                question: "What does 'Node Package Manager (npm)' help you manage in a Node.js project?",
                options: ["Project hardware requirements", "Development servers", "Project dependencies and packages", "Front-end design styles"],
                correctAnswer: "Project dependencies and packages",
                category: "Node.js"
            },
            {
                question: "What is 'Node.js REPL' used for?",
                options: ["To create web servers", "To run JavaScript code interactively", "To manipulate the file system", "To manage HTTP requests"],
                correctAnswer: "To run JavaScript code interactively",
                category: "Node.js"
            },
            {
                question: "What is the role of 'event emitters' in Node.js?",
                options: ["To add event listeners", "To create animations", "To calculate mathematical operations", "To handle and trigger events"],
                correctAnswer: "To handle and trigger events",
                category: "Node.js"
            },
            {
                question: "What is the 'package.json' file used for in a Node.js project?",
                options: ["To store binary data", "To define CSS styles", "To specify project metadata and dependencies", "To run unit tests"],
                correctAnswer: "To specify project metadata and dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm audit' used for in Node.js?",
                options: ["To generate API documentation", "To uninstall a package", "To analyze and report security vulnerabilities in project dependencies", "To format strings"],
                correctAnswer: "To analyze and report security vulnerabilities in project dependencies",
                category: "Node.js"
            },
            {
                question: "What does the 'event loop' in Node.js handle?",
                options: ["HTTP requests", "Asynchronous operations", "Mathematical calculations", "File operations"],
                correctAnswer: "Asynchronous operations",
                category: "Node.js"
            },
            {
                question: "What is the primary purpose of the 'fs' (File System) module in Node.js?",
                options: ["To create web servers", "To manipulate and interact with the file system", "To manage databases", "To handle HTTP requests"],
                correctAnswer: "To manipulate and interact with the file system",
                category: "Node.js"
            }
        ],
        '8no': [
            {
                question: "What is the primary role of the 'express' module in Node.js?",
                options: ["To define CSS styles", "To manipulate binary data", "To create web servers", "To build and manage web applications"],
                correctAnswer: "To build and manage web applications",
                category: "Node.js"
            },
            {
                question: "What is 'npm run build' used for in a Node.js project?",
                options: ["To start the application", "To uninstall a package", "To build and bundle project code for production", "To generate API documentation"],
                correctAnswer: "To build and bundle project code for production",
                category: "Node.js"
            },
            {
                question: "What is the 'process' object in Node.js used for?",
                options: ["To handle asynchronous operations", "To define routes for web applications", "To manage databases", "To provide information about the current Node.js process"],
                correctAnswer: "To provide information about the current Node.js process",
                category: "Node.js"
            },
            {
                question: "What is 'WebSocket' in the context of Node.js?",
                options: ["A database management system", "A communication protocol for enabling bidirectional communication between a client and server", "A Node.js package manager", "A JavaScript testing framework"],
                correctAnswer: "A communication protocol for enabling bidirectional communication between a client and server",
                category: "Node.js"
            },
            {
                question: "What is the role of the 'crypto' module in Node.js?",
                options: ["To create web servers", "To encrypt and decrypt data", "To manipulate binary data", "To define CSS styles"],
                correctAnswer: "To encrypt and decrypt data",
                category: "Node.js"
            },
            {
                question: "What is 'npm publish' used for in Node.js?",
                options: ["To create a new project", "To uninstall a package", "To share a package with the global Node.js community", "To generate API documentation"],
                correctAnswer: "To share a package with the global Node.js community",
                category: "Node.js"
            },
            {
                question: "What is 'npm test' used for in a Node.js project?",
                options: ["To analyze and report security vulnerabilities", "To create a new project", "To execute unit tests defined in the 'scripts' section of 'package.json'", "To start a development server"],
                correctAnswer: "To execute unit tests defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm install --save' used for in Node.js?",
                options: ["To uninstall a package", "To install a package and add it to the 'dependencies' section of 'package.json'", "To start the application", "To generate API documentation"],
                correctAnswer: "To install a package and add it to the 'dependencies' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm update' used for in Node.js?",
                options: ["To create a new project", "To uninstall a package", "To update all packages to their latest versions", "To execute unit tests"],
                correctAnswer: "To update all packages to their latest versions",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'util' module in Node.js?",
                options: ["To manipulate binary data", "To create web servers", "To provide utility functions for common programming tasks", "To manage databases"],
                correctAnswer: "To provide utility functions for common programming tasks",
                category: "Node.js"
            }
        ],
        'up-9no': [
            {
                question: "What is the primary role of the 'express' module in Node.js?",
                options: ["To define CSS styles", "To manipulate binary data", "To create web servers", "To build and manage web applications"],
                correctAnswer: "To build and manage web applications",
                category: "Node.js"
            },
            {
                question: "What is 'npm run build' used for in a Node.js project?",
                options: ["To start the application", "To uninstall a package", "To build and bundle project code for production", "To generate API documentation"],
                correctAnswer: "To build and bundle project code for production",
                category: "Node.js"
            },
            {
                question: "What is the 'process' object in Node.js used for?",
                options: ["To handle asynchronous operations", "To define routes for web applications", "To manage databases", "To provide information about the current Node.js process"],
                correctAnswer: "To provide information about the current Node.js process",
                category: "Node.js"
            },
            {
                question: "What is 'WebSocket' in the context of Node.js?",
                options: ["A database management system", "A communication protocol for enabling bidirectional communication between a client and server", "A Node.js package manager", "A JavaScript testing framework"],
                correctAnswer: "A communication protocol for enabling bidirectional communication between a client and server",
                category: "Node.js"
            },
            {
                question: "What is the role of the 'crypto' module in Node.js?",
                options: ["To create web servers", "To encrypt and decrypt data", "To manipulate binary data", "To define CSS styles"],
                correctAnswer: "To encrypt and decrypt data",
                category: "Node.js"
            },
            {
                question: "What is 'npm publish' used for in Node.js?",
                options: ["To create a new project", "To uninstall a package", "To share a package with the global Node.js community", "To generate API documentation"],
                correctAnswer: "To share a package with the global Node.js community",
                category: "Node.js"
            },
            {
                question: "What is 'npm test' used for in a Node.js project?",
                options: ["To analyze and report security vulnerabilities", "To create a new project", "To execute unit tests defined in the 'scripts' section of 'package.json'", "To start a development server"],
                correctAnswer: "To execute unit tests defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm install --save' used for in Node.js?",
                options: ["To uninstall a package", "To install a package and add it to the 'dependencies' section of 'package.json'", "To start the application", "To generate API documentation"],
                correctAnswer: "To install a package and add it to the 'dependencies' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm update' used for in Node.js?",
                options: ["To create a new project", "To uninstall a package", "To update all packages to their latest versions", "To execute unit tests"],
                correctAnswer: "To update all packages to their latest versions",
                category: "Node.js"
            },
            {
                question: "What is the purpose of the 'util' module in Node.js?",
                options: ["To manipulate binary data", "To create web servers", "To provide utility functions for common programming tasks", "To manage databases"],
                correctAnswer: "To provide utility functions for common programming tasks",
                category: "Node.js"
            }
        ],
        '10no': [
            {
                question: "What is 'npm prune' used for in Node.js?",
                options: ["To trim excess branches from a tree", "To remove unused dependencies from a project", "To create a new Node.js project", "To generate documentation"],
                correctAnswer: "To remove unused dependencies from a project",
                category: "Node.js"
            },
            {
                question: "What is 'npm link' used for in Node.js?",
                options: ["To establish a hyperlink between web pages", "To update Node.js to the latest version", "To share a package with the global Node.js community", "To execute unit tests"],
                correctAnswer: "To establish a symlink between a package and a project, allowing local development of the package",
                category: "Node.js"
            },
            {
                question: "What is 'npm run' used for in Node.js?",
                options: ["To play audio files", "To run custom scripts defined in the 'scripts' section of 'package.json'", "To uninstall packages", "To create animations"],
                correctAnswer: "To run custom scripts defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm link' used for in Node.js?",
                options: ["To establish a hyperlink between web pages", "To update Node.js to the latest version", "To share a package with the global Node.js community", "To execute unit tests"],
                correctAnswer: "To establish a symlink between a package and a project, allowing local development of the package",
                category: "Node.js"
            },
            {
                question: "What is the 'child_process' module in Node.js used for?",
                options: ["To manage child elements in HTML", "To create child processes and execute external commands", "To manipulate images", "To perform data analysis"],
                correctAnswer: "To create child processes and execute external commands",
                category: "Node.js"
            },
            {
                question: "What is 'npm list' used for in Node.js?",
                options: ["To list available Node.js versions", "To list the installed packages and their dependencies", "To generate API documentation", "To uninstall a package"],
                correctAnswer: "To list the installed packages and their dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm cache' used for in Node.js?",
                options: ["To store temporary data for faster package installations", "To cache HTML web pages", "To run unit tests", "To create animations"],
                correctAnswer: "To store temporary data for faster package installations",
                category: "Node.js"
            },
            {
                question: "What is the 'os' module in Node.js used for?",
                options: ["To create operating systems", "To manipulate images", "To work with operating system-related information", "To manage databases"],
                correctAnswer: "To work with operating system-related information",
                category: "Node.js"
            },
            {
                question: "What is 'npm shrinkwrap' used for in Node.js?",
                options: ["To minimize the size of project files", "To wrap packages as gifts", "To generate API documentation", "To lock down the versions of a project's dependencies"],
                correctAnswer: "To lock down the versions of a project's dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm outdated' used for in Node.js?",
                options: ["To determine if a project is no longer popular", "To find outdated code in a project", "To check for outdated project dependencies", "To create animations"],
                correctAnswer: "To check for outdated project dependencies",
                category: "Node.js"
            }
        ],
        '11no': [
            {
                question: "What is 'npm scripts' used for in Node.js projects?",
                options: ["To run JavaScript code directly in the console", "To execute custom scripts defined in the 'scripts' section of 'package.json'", "To create a new project", "To install global packages"],
                correctAnswer: "To execute custom scripts defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm link' used for in Node.js?",
                options: ["To establish a hyperlink between web pages", "To update Node.js to the latest version", "To share a package with the global Node.js community", "To execute unit tests"],
                correctAnswer: "To establish a symlink between a package and a project, allowing local development of the package",
                category: "Node.js"
            },
            {
                question: "What is the 'child_process' module in Node.js used for?",
                options: ["To manage child elements in HTML", "To create child processes and execute external commands", "To manipulate images", "To perform data analysis"],
                correctAnswer: "To create child processes and execute external commands",
                category: "Node.js"
            },
            {
                question: "What is 'npm list' used for in Node.js?",
                options: ["To list available Node.js versions", "To list the installed packages and their dependencies", "To generate API documentation", "To uninstall a package"],
                correctAnswer: "To list the installed packages and their dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm cache' used for in Node.js?",
                options: ["To store temporary data for faster package installations", "To cache HTML web pages", "To run unit tests", "To create animations"],
                correctAnswer: "To store temporary data for faster package installations",
                category: "Node.js"
            },
            {
                question: "What is the 'os' module in Node.js used for?",
                options: ["To create operating systems", "To manipulate images", "To work with operating system-related information", "To manage databases"],
                correctAnswer: "To work with operating system-related information",
                category: "Node.js"
            },
            {
                question: "What is 'npm shrinkwrap' used for in Node.js?",
                options: ["To minimize the size of project files", "To wrap packages as gifts", "To generate API documentation", "To lock down the versions of a project's dependencies"],
                correctAnswer: "To lock down the versions of a project's dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm outdated' used for in Node.js?",
                options: ["To determine if a project is no longer popular", "To find outdated code in a project", "To check for outdated project dependencies", "To create animations"],
                correctAnswer: "To check for outdated project dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm config' used for in Node.js?",
                options: ["To configure the Node.js runtime environment", "To set up a local development server", "To create web servers", "To manage databases"],
                correctAnswer: "To configure the Node.js runtime environment",
                category: "Node.js"
            },
            {
                question: "What is 'pm2' in the context of Node.js?",
                options: ["A version control system", "A package manager", "A process manager for running Node.js applications", "A coding framework"],
                correctAnswer: "A process manager for running Node.js applications",
                category: "Node.js"
            }
        ],
        'up-12no': [
            {
                question: "What is 'npm scripts' used for in Node.js projects?",
                options: ["To run JavaScript code directly in the console", "To execute custom scripts defined in the 'scripts' section of 'package.json'", "To create a new project", "To install global packages"],
                correctAnswer: "To execute custom scripts defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is 'npm update' used for in Node.js?",
                options: ["To create a new project", "To uninstall a package", "To update all packages to their latest versions", "To execute unit tests"],
                correctAnswer: "To update all packages to their latest versions",
                category: "Node.js"
            },
            {
                question: "What is 'pm2' in the context of Node.js?",
                options: ["A version control system", "A package manager", "A process manager for running Node.js applications", "A coding framework"],
                correctAnswer: "A process manager for running Node.js applications",
                category: "Node.js"
            },
            {
                question: "What is 'npm scripts' used for in Node.js projects?",
                options: ["To run JavaScript code directly in the console", "To execute custom scripts defined in the 'scripts' section of 'package.json'", "To create a new project", "To install global packages"],
                correctAnswer: "To execute custom scripts defined in the 'scripts' section of 'package.json'",
                category: "Node.js"
            },
            {
                question: "What is the 'child_process' module in Node.js used for?",
                options: ["To manage child elements in HTML", "To create child processes and execute external commands", "To manipulate images", "To perform data analysis"],
                correctAnswer: "To create child processes and execute external commands",
                category: "Node.js"
            },
            {
                question: "What is 'npm list' used for in Node.js?",
                options: ["To list available Node.js versions", "To list the installed packages and their dependencies", "To generate API documentation", "To uninstall a package"],
                correctAnswer: "To list the installed packages and their dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm cache' used for in Node.js?",
                options: ["To store temporary data for faster package installations", "To cache HTML web pages", "To run unit tests", "To create animations"],
                correctAnswer: "To store temporary data for faster package installations",
                category: "Node.js"
            },
            {
                question: "What is the 'os' module in Node.js used for?",
                options: ["To create operating systems", "To manipulate images", "To work with operating system-related information", "To manage databases"],
                correctAnswer: "To work with operating system-related information",
                category: "Node.js"
            },
            {
                question: "What is 'npm shrinkwrap' used for in Node.js?",
                options: ["To minimize the size of project files", "To wrap packages as gifts", "To generate API documentation", "To lock down the versions of a project's dependencies"],
                correctAnswer: "To lock down the versions of a project's dependencies",
                category: "Node.js"
            },
            {
                question: "What is 'npm outdated' used for in Node.js?",
                options: ["To determine if a project is no longer popular", "To find outdated code in a project", "To check for outdated project dependencies", "To create animations"],
                correctAnswer: "To check for outdated project dependencies",
                category: "Node.js"
            }
        ]
    },
    JAVA: {
        '1no': [
            {
                question: "What does 'JVM' stand for in Java?",
                options: ["Java Virtual Machine", "JavaScript Virtual Model", "Java Validation Module", "Java Version Manager"],
                correctAnswer: "Java Virtual Machine",
                category: "JAVA"
            },
            {
                question: "What is the 'main' method in a Java program used for?",
                options: ["To print 'Hello, World!'", "To define a class", "To specify command-line arguments", "To start the program's execution"],
                correctAnswer: "To start the program's execution",
                category: "JAVA"
            },
            {
                question: "In Java, which access modifier is used for a method or field that is accessible within the same package?",
                options: ["public", "private", "protected", "package-private (default)"],
                correctAnswer: "package-private (default)",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'new' keyword in Java?",
                options: ["To create a new class", "To instantiate an object", "To define a constructor", "To delete an object"],
                correctAnswer: "To instantiate an object",
                category: "JAVA"
            },
            {
                question: "In Java, which data type is used to represent a sequence of characters?",
                options: ["int", "boolean", "String", "double"],
                correctAnswer: "String",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to indicate that a variable does not have a value?",
                options: ["empty", "null", "void", "undefined"],
                correctAnswer: "null",
                category: "JAVA"
            },
            {
                question: "Which Java keyword is used to declare a constant variable?",
                options: ["let", "var", "const", "final"],
                correctAnswer: "final",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'static' keyword in Java?",
                options: ["To make a variable non-modifiable", "To create a new instance of a class", "To indicate a class member that belongs to the class itself, rather than to instances of the class", "To stop the execution of a program"],
                correctAnswer: "To indicate a class member that belongs to the class itself, rather than to instances of the class",
                category: "JAVA"
            },
            {
                question: "What is an 'interface' in Java?",
                options: ["A class that cannot be instantiated", "A collection of classes", "A type of loop", "A contract that defines a set of methods that a class must implement"],
                correctAnswer: "A contract that defines a set of methods that a class must implement",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'try...catch' block used for?",
                options: ["To define a class", "To create an object", "To handle exceptions and errors", "To declare a constructor"],
                correctAnswer: "To handle exceptions and errors",
                category: "JAVA"
            }
        ],
        '2no': [
            {
                question: "What is the Java keyword used to create a new instance of a class?",
                options: ["new", "create", "instantiate", "instance"],
                correctAnswer: "new",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'extends' keyword in class declarations?",
                options: ["To define a class", "To declare a constructor", "To create an instance of a class", "To specify inheritance from another class"],
                correctAnswer: "To specify inheritance from another class",
                category: "JAVA"
            },
            {
                question: "What is the role of the 'break' statement in a Java switch statement?",
                options: ["To exit the switch statement and continue with the next case", "To execute the current case and move to the next one", "To start the switch statement", "To define a class"],
                correctAnswer: "To exit the switch statement and continue with the next case",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'super' keyword in Java?",
                options: ["To refer to a superclass or parent class", "To call a static method", "To define a constructor", "To create a new object"],
                correctAnswer: "To refer to a superclass or parent class",
                category: "JAVA"
            },
            {
                question: "In Java, which operator is used to compare two values for equality?",
                options: ["==", "===", "!=", "!=="],
                correctAnswer: "===",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to exit a loop prematurely?",
                options: ["exit", "break", "continue", "stop"],
                correctAnswer: "break",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'this' keyword in Java?",
                options: ["It refers to the current file", "It refers to the previous value", "It refers to the current object", "It refers to a specific function"],
                correctAnswer: "It refers to the current object",
                category: "JAVA"
            },
            {
                question: "What is a 'constructor' in Java?",
                options: ["A method that constructs objects", "A class that cannot be instantiated", "A type of loop", "A variable declared outside a method"],
                correctAnswer: "A method that constructs objects",
                category: "JAVA"
            },
            {
                question: "What is the Java 'try...catch' block used for?",
                options: ["To declare a class", "To create an object", "To handle exceptions and errors", "To define a constructor"],
                correctAnswer: "To handle exceptions and errors",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'abstract' keyword in Java?",
                options: ["To make a class final and non-inheritable", "To indicate that a method has no implementation", "To create an instance of a class", "To define a class"],
                correctAnswer: "To indicate that a method has no implementation",
                category: "JAVA"
            }
        ],
        '3no': [
            {
                question: "What is the purpose of the 'public' access modifier in Java?",
                options: ["To make a variable non-modifiable", "To specify that a class is final", "To define a class", "To allow access from any other class"],
                correctAnswer: "To allow access from any other class",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'final' keyword used for?",
                options: ["To prevent inheritance of a class", "To indicate a class is abstract", "To create a new instance of a class", "To define a constructor"],
                correctAnswer: "To prevent inheritance of a class",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'package' declaration in a Java class?",
                options: ["To declare a variable", "To specify a package for the class", "To create a new object", "To start the program's execution"],
                correctAnswer: "To specify a package for the class",
                category: "JAVA"
            },
            {
                question: "In Java, which data type is used to represent integer values?",
                options: ["int", "boolean", "String", "double"],
                correctAnswer: "int",
                category: "JAVA"
            },
            {
                question: "What is the Java 'while' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code while a condition is true", "To start the program's execution"],
                correctAnswer: "To repeat a block of code while a condition is true",
                category: "JAVA"
            },
            {
                question: "What does 'OOP' stand for in the context of Java programming?",
                options: ["Order of Operations in Programming", "Object-Oriented Programming", "Object-Oriented Process", "Optimized Object Programming"],
                correctAnswer: "Object-Oriented Programming",
                category: "JAVA"
            },
            {
                question: "What is the Java 'if...else' statement used for?",
                options: ["To declare a class", "To create an object", "To test a condition and execute different code based on the result", "To define a constructor"],
                correctAnswer: "To test a condition and execute different code based on the result",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'return' statement in a Java method?",
                options: ["To print a message to the console", "To define a class", "To indicate the end of a method's execution and return a value", "To start the program's execution"],
                correctAnswer: "To indicate the end of a method's execution and return a value",
                category: "JAVA"
            },
            {
                question: "In Java, what is a 'class'?",
                options: ["A way to define an object's behavior", "A collection of methods", "A loop structure", "A type of data"],
                correctAnswer: "A way to define an object's behavior",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            }
        ],
        '4no': [
            {
                question: "What is the purpose of the 'try...catch...finally' block in Java?",
                options: ["To define a class", "To create an object", "To handle exceptions and errors, and ensure cleanup code is executed", "To start the program's execution"],
                correctAnswer: "To handle exceptions and errors, and ensure cleanup code is executed",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'while' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code while a condition is true", "To test a condition and execute different code based on the result"],
                correctAnswer: "To repeat a block of code while a condition is true",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'default' keyword used for in a 'switch' statement?",
                options: ["To define a class", "To specify the default case when no other cases match", "To create an object", "To test a condition and execute different code based on the result"],
                correctAnswer: "To specify the default case when no other cases match",
                category: "JAVA"
            },
            {
                question: "What is the 'Encapsulation' concept in Java used for?",
                options: ["To create a new class", "To hide the internal state of an object and expose only the necessary functionality", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To hide the internal state of an object and expose only the necessary functionality",
                category: "JAVA"
            },
            {
                question: "What is the Java 'for' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code for a specified number of times", "To test a condition and execute different code based on the result"],
                correctAnswer: "To repeat a block of code for a specified number of times",
                category: "JAVA"
            },
            {
                question: "What is the 'Interface' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To specify a contract that classes must implement", "To declare a variable"],
                correctAnswer: "To specify a contract that classes must implement",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to invoke a superclass constructor from a subclass?",
                options: ["superclass", "super", "this", "parent"],
                correctAnswer: "super",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'break' statement used for in a loop?",
                options: ["To exit the loop and continue with the next iteration", "To exit the loop and continue with the code after the loop", "To define a class", "To create an object"],
                correctAnswer: "To exit the loop and continue with the code after the loop",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            }
        ],
        '5no': [
            {
                question: "What is the purpose of the 'try...catch...finally' block in Java?",
                options: ["To define a class", "To create an object", "To handle exceptions and errors, and ensure cleanup code is executed", "To start the program's execution"],
                correctAnswer: "To handle exceptions and errors, and ensure cleanup code is executed",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'while' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code while a condition is true", "To test a condition and execute different code based on the result"],
                correctAnswer: "To repeat a block of code while a condition is true",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'default' keyword used for in a 'switch' statement?",
                options: ["To define a class", "To specify the default case when no other cases match", "To create an object", "To test a condition and execute different code based on the result"],
                correctAnswer: "To specify the default case when no other cases match",
                category: "JAVA"
            },
            {
                question: "What is the 'Encapsulation' concept in Java used for?",
                options: ["To create a new class", "To hide the internal state of an object and expose only the necessary functionality", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To hide the internal state of an object and expose only the necessary functionality",
                category: "JAVA"
            },
            {
                question: "What is the Java 'for' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code for a specified number of times", "To test a condition and execute different code based on the result"],
                correctAnswer: "To repeat a block of code for a specified number of times",
                category: "JAVA"
            },
            {
                question: "What is the 'Interface' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To specify a contract that classes must implement", "To declare a variable"],
                correctAnswer: "To specify a contract that classes must implement",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to invoke a superclass constructor from a subclass?",
                options: ["superclass", "super", "this", "parent"],
                correctAnswer: "super",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'break' statement used for in a loop?",
                options: ["To exit the loop and continue with the next iteration", "To exit the loop and continue with the code after the loop", "To define a class", "To create an object"],
                correctAnswer: "To exit the loop and continue with the code after the loop",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            }
        ],
        '6no': [
            {
                question: "What is the 'inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow a class to acquire the properties and methods of another class", "To declare a variable"],
                correctAnswer: "To allow a class to acquire the properties and methods of another class",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'finally' block in a 'try...catch' statement?",
                options: ["To define a class", "To create an object", "To handle exceptions and errors", "To ensure code is executed regardless of exceptions"],
                correctAnswer: "To ensure code is executed regardless of exceptions",
                category: "JAVA"
            },
            {
                question: "What is the Java 'switch' statement used for?",
                options: ["To define a class", "To create an object", "To perform different actions based on different cases", "To test a condition and execute different code based on the result"],
                correctAnswer: "To perform different actions based on different cases",
                category: "JAVA"
            },
            {
                question: "What is the 'Encapsulation' concept in Java used for?",
                options: ["To create a new class", "To hide the internal state of an object and expose only the necessary functionality", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To hide the internal state of an object and expose only the necessary functionality",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'static' keyword used for with variables?",
                options: ["To make a variable non-modifiable", "To indicate that a variable is shared among all instances of a class", "To create a new instance of a class", "To declare a constructor"],
                correctAnswer: "To indicate that a variable is shared among all instances of a class",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to invoke the superclass constructor from a subclass constructor?",
                options: ["superclass", "super", "this", "parent"],
                correctAnswer: "super",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'instanceof' operator?",
                options: ["To check if a variable is undefined", "To determine if an object is an instance of a particular class", "To define a class", "To create an object"],
                correctAnswer: "To determine if an object is an instance of a particular class",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'default' keyword in a Java 'case' statement within a 'switch' block?",
                options: ["To create a new class", "To specify the default case when no other cases match", "To create an object", "To test a condition and execute different code based on the result"],
                correctAnswer: "To specify the default case when no other cases match",
                category: "JAVA"
            },
            {
                question: "What is the 'Abstraction' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To simplify complex systems by modeling classes based on their essential features", "To declare a variable"],
                correctAnswer: "To simplify complex systems by modeling classes based on their essential features",
                category: "JAVA"
            }
        ],
        '7no': [
            {
                question: "What is the purpose of the 'static' keyword in Java with respect to methods?",
                options: ["To make a method non-modifiable", "To indicate that a method belongs to the class, not to instances of the class", "To create a new class", "To declare a constructor"],
                correctAnswer: "To indicate that a method belongs to the class, not to instances of the class",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'break' statement used for in a loop?",
                options: ["To exit the loop and continue with the next iteration", "To exit the loop and continue with the code after the loop", "To define a class", "To create an object"],
                correctAnswer: "To exit the loop and continue with the code after the loop",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'volatile' keyword in Java?",
                options: ["To make a variable non-modifiable", "To indicate that a variable can be accessed by multiple threads", "To create a new class", "To create an object"],
                correctAnswer: "To indicate that a variable can be accessed by multiple threads",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'continue' statement used for in a loop?",
                options: ["To exit the loop and continue with the code after the loop", "To skip the current iteration and continue with the next iteration of the loop", "To define a class", "To create an object"],
                correctAnswer: "To skip the current iteration and continue with the next iteration of the loop",
                category: "JAVA"
            },
            {
                question: "What is the 'synchronized' keyword in Java used for?",
                options: ["To make a variable non-modifiable", "To create a new class", "To allow multiple threads to execute a synchronized block mutually exclusively", "To declare a constructor"],
                correctAnswer: "To allow multiple threads to execute a synchronized block mutually exclusively",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'implements' keyword in a class declaration?",
                options: ["To define a class", "To specify a class's inheritance", "To create an object", "To indicate that a class implements an interface"],
                correctAnswer: "To indicate that a class implements an interface",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to invoke the superclass constructor from a subclass constructor?",
                options: ["superclass", "super", "this", "parent"],
                correctAnswer: "super",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'instanceof' operator?",
                options: ["To check if a variable is undefined", "To determine if an object is an instance of a particular class", "To define a class", "To create an object"],
                correctAnswer: "To determine if an object is an instance of a particular class",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            }
        ],
        '8no': [
            {
                question: "What is the purpose of the 'static' keyword in Java with respect to methods?",
                options: ["To make a method non-modifiable", "To indicate that a method belongs to the class, not to instances of the class", "To create a new class", "To declare a constructor"],
                correctAnswer: "To indicate that a method belongs to the class, not to instances of the class",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'break' statement used for in a loop?",
                options: ["To exit the loop and continue with the next iteration", "To exit the loop and continue with the code after the loop", "To define a class", "To create an object"],
                correctAnswer: "To exit the loop and continue with the code after the loop",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'volatile' keyword in Java?",
                options: ["To make a variable non-modifiable", "To indicate that a variable can be accessed by multiple threads", "To create a new class", "To create an object"],
                correctAnswer: "To indicate that a variable can be accessed by multiple threads",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'continue' statement used for in a loop?",
                options: ["To exit the loop and continue with the code after the loop", "To skip the current iteration and continue with the next iteration of the loop", "To define a class", "To create an object"],
                correctAnswer: "To skip the current iteration and continue with the next iteration of the loop",
                category: "JAVA"
            },
            {
                question: "What is the 'synchronized' keyword in Java used for?",
                options: ["To make a variable non-modifiable", "To create a new class", "To allow multiple threads to execute a synchronized block mutually exclusively", "To declare a constructor"],
                correctAnswer: "To allow multiple threads to execute a synchronized block mutually exclusively",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'implements' keyword in a class declaration?",
                options: ["To define a class", "To specify a class's inheritance", "To create an object", "To indicate that a class implements an interface"],
                correctAnswer: "To indicate that a class implements an interface",
                category: "JAVA"
            },
            {
                question: "What is the Java keyword used to invoke the superclass constructor from a subclass constructor?",
                options: ["superclass", "super", "this", "parent"],
                correctAnswer: "super",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'instanceof' operator?",
                options: ["To check if a variable is undefined", "To determine if an object is an instance of a particular class", "To define a class", "To create an object"],
                correctAnswer: "To determine if an object is an instance of a particular class",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            }
        ],
        '9no': [
            {
                question: "What is the Java 'switch' statement used for?",
                options: ["To define a class", "To create an object", "To perform different actions based on different cases", "To test a condition and execute different code based on the result"],
                correctAnswer: "To perform different actions based on different cases",
                category: "JAVA"
            },
            {
                question: "What is the Java 'do...while' loop used for?",
                options: ["To define a class", "To create an object", "To repeat a block of code at least once and then continue while a condition is true", "To test a condition and execute different code based on the result"],
                correctAnswer: "To repeat a block of code at least once and then continue while a condition is true",
                category: "JAVA"
            },
            {
                question: "What is the 'Abstraction' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To simplify complex systems by modeling classes based on their essential features", "To declare a variable"],
                correctAnswer: "To simplify complex systems by modeling classes based on their essential features",
                category: "JAVA"
            },
            {
                question: "In Java, what is the purpose of the 'implements' keyword in a class declaration?",
                options: ["To define a class", "To specify a class's inheritance", "To create an object", "To indicate that a class implements an interface"],
                correctAnswer: "To indicate that a class implements an interface",
                category: "JAVA"
            },
            {
                question: "What is the 'Polymorphism' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To allow objects of different classes to be treated as objects of a common superclass", "To declare a variable"],
                correctAnswer: "To allow objects of different classes to be treated as objects of a common superclass",
                category: "JAVA"
            },
            {
                question: "What is the Java 'break' statement used for in a 'switch' statement?",
                options: ["To exit the switch statement and continue with the next case", "To exit the switch statement and continue with the code after the switch", "To define a class", "To create an object"],
                correctAnswer: "To exit the switch statement and continue with the code after the switch",
                category: "JAVA"
            },
            {
                question: "What is the purpose of the 'volatile' keyword in Java?",
                options: ["To make a variable non-modifiable", "To indicate that a variable can be accessed by multiple threads", "To define a class", "To create an object"],
                correctAnswer: "To indicate that a variable can be accessed by multiple threads",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'static' keyword used for with variables?",
                options: ["To make a variable non-modifiable", "To indicate that a variable is shared among all instances of a class", "To create a new instance of a class", "To declare a constructor"],
                correctAnswer: "To indicate that a variable is shared among all instances of a class",
                category: "JAVA"
            },
            {
                question: "What is the 'Inheritance' concept in Java used for?",
                options: ["To create a new class", "To define a constructor", "To create a subclass that inherits properties and methods from a superclass", "To declare a variable"],
                correctAnswer: "To create a subclass that inherits properties and methods from a superclass",
                category: "JAVA"
            },
            {
                question: "In Java, what is the 'instanceof' operator used for?",
                options: ["To check if a variable is undefined", "To determine if an object is an instance of a particular class", "To define a class", "To create an object"],
                correctAnswer: "To determine if an object is an instance of a particular class",
                category: "JAVA"
            }
        ]
    }
}